"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5973,4557,2948,42,1868,9996],{

/***/ 123483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var CloseIconBlack = function(param) {
    var size = param.size;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        width: size,
        height: size,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M9.46584 8.00012L15.6959 1.76972C16.1014 1.36446 16.1014 0.709208 15.6959 0.303946C15.2907 -0.101315 14.6354 -0.101315 14.2302 0.303946L7.99991 6.53434L1.76983 0.303946C1.36438 -0.101315 0.709335 -0.101315 0.304082 0.303946C-0.101361 0.709208 -0.101361 1.36446 0.304082 1.76972L6.53416 8.00012L0.304082 14.2305C-0.101361 14.6358 -0.101361 15.291 0.304082 15.6963C0.506044 15.8984 0.771594 16 1.03695 16C1.30231 16 1.56767 15.8984 1.76983 15.6963L7.99991 9.46589L14.2302 15.6963C14.4323 15.8984 14.6977 16 14.963 16C15.2284 16 15.4938 15.8984 15.6959 15.6963C16.1014 15.291 16.1014 14.6358 15.6959 14.2305L9.46584 8.00012Z",
            fill: "black"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CloseIconBlack);


/***/ }),

/***/ 72084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ TickFill; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);



function TickFill(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || 29.25,
        height: props.height || 29.25,
        viewBox: "0 0 29.25 29.25"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M14.625 0A14.625 14.625 0 1029.25 14.625 14.623 14.623 0 0014.625 0zm7.488 10.582l-9.4 9.443h-.008a1.27 1.27 0 01-.816.387 1.231 1.231 0 01-.823-.4l-3.941-3.939a.28.28 0 010-.4l1.256-1.248a.272.272 0 01.394 0l3.122 3.122 8.578-8.641a.278.278 0 01.2-.084.255.255 0 01.2.084l1.23 1.273a.277.277 0 01.008.403z",
            fill: props.color || "#000000"
        })
    }));
}


/***/ }),

/***/ 698521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CouponsAndVouchers_PromoSlider; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/BasicSlider/index.tsx + 2 modules
var BasicSlider = __webpack_require__(9997);
// EXTERNAL MODULE: ./src/assets/svgExports/OfferIcon.js
var OfferIcon = __webpack_require__(493757);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/index.tsx
var Common = __webpack_require__(192134);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(168615);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromoSlide/index.tsx






var PromoSlide = function(param) {
    var promoData = param.promoData;
    var openProductDetailsModal = function openProductDetailsModal() {
        dispatch((0,promo/* togglePromoDetailModal */.wl)({
            show: true,
            promoId: promoData === null || promoData === void 0 ? void 0 : promoData.id
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var offerIconSize = checkClientDeviceType/* IS_DESKTOP */.yn ? 15 : 12;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "!tw-flex tw-items-start tw-justify-between tw-border tw-border-solid tw-border-[#E3E3E3] tw-px-[16px] tw-py-[12px] md:tw-items-center md:tw-px-[24px] md:tw-py-[16px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-gap-[2px]",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "tw-m-0 tw-text-[12px]/[20px] md:tw-text-[15px]/[20px]",
                        children: "Special Offer"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-m-0 tw-flex tw-gap-[4px] md:tw-gap-[8px]",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-mt-[4px] tw-flex md:tw-mt-[2.5px]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferIcon/* default */.Z, {
                                    height: offerIconSize,
                                    width: offerIconSize
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "tw-m-0 tw-text-[12px]/[20px] tw-font-semibold md:tw-text-[16px]/[20px]",
                                        children: promoData === null || promoData === void 0 ? void 0 : promoData.description
                                    }),
                                    !checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "tw-m-0 tw-text-[11px]/[20px] tw-text-[#575757]",
                                        children: [
                                            "Use Code - ",
                                            promoData === null || promoData === void 0 ? void 0 : promoData.code
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-gap-[24px]",
                children: [
                    checkClientDeviceType/* IS_DESKTOP */.yn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "tw-border tw-border-dashed tw-px-[12px] tw-py-[8px] tw-text-[14px]/[20px] tw-font-semibold",
                        children: [
                            "Use Code - ",
                            promoData === null || promoData === void 0 ? void 0 : promoData.code
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Common/* StripCTA */.iQ, {
                        onClick: openProductDetailsModal
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var CouponsAndVouchers_PromoSlide = (PromoSlide);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromoSlider/index.tsx








var PromoSlider = function(param) {
    var type = param.type, typeId = param.typeId, _customClasses = param.customClasses, customClasses = _customClasses === void 0 ? "" : _customClasses, _setPromosDataToParent = param.setPromosDataToParent, setPromosDataToParent = _setPromosDataToParent === void 0 ? null : _setPromosDataToParent;
    var getSliderPromos = function getSliderPromos() {
        typeId = Number(typeId);
        if (isNaN(typeId) || typeId < 0) {
            return;
        }
        var data = {
            type: type,
            type_ids: [
                typeId
            ],
            store_id: storeId,
            user_id: userId
        };
        dispatch((0,promo/* getPromosByTypeAndTypeId */.Lr)(data, function(data) {
            setPromosDataToParent(data);
            setPromosData(data);
        }));
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,react.useState)([]), promosData = ref[0], setPromosData = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return {
            storeId: state.storeReducer.store.store_id,
            userId: ((ref = state.userReducer.data) === null || ref === void 0 ? void 0 : ref.user_id) || 0
        };
    }), storeId = ref1.storeId, userId = ref1.userId;
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    (0,react.useEffect)(function() {
        if (type && typeId >= 0 && !isCouponsFeatureLocked) {
            getSliderPromos();
        }
    }, []);
    return !!(promosData === null || promosData === void 0 ? void 0 : promosData.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "tw-w-full ".concat(checkClientDeviceType/* IS_DESKTOP */.yn ? "tw-mb-[24px]" : "tw-mb-[36px]", " ").concat(customClasses),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BasicSlider/* default */.Z, {
            showArrows: checkClientDeviceType/* IS_DESKTOP */.yn && (promosData === null || promosData === void 0 ? void 0 : promosData.length) > 1,
            showDots: !checkClientDeviceType/* IS_DESKTOP */.yn,
            children: promosData.map(function(promoData, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CouponsAndVouchers_PromoSlide, {
                    promoData: promoData
                }, index);
            })
        })
    });
};
/* harmony default export */ var CouponsAndVouchers_PromoSlider = (PromoSlider);


/***/ }),

/***/ 590042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CouponsAndVouchers_PromosDrawerAndButton; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(758826);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./src/utils/getThemeColor.js
var getThemeColor = __webpack_require__(270758);
// EXTERNAL MODULE: ./src/assets/svgExports/CloseIconBlack.js
var CloseIconBlack = __webpack_require__(123483);
;// CONCATENATED MODULE: ./src/components/FloatingButtonAndDrawer/index.tsx






var FloatingButtonAndDrawer = function(param) {
    var buttonConfig = param.buttonConfig, showDrawer = param.showDrawer, onClose = param.onClose, drawerHeading = param.drawerHeading, additionalHeaderComponent = param.additionalHeaderComponent, children = param.children, showCloseIcon = param.showCloseIcon;
    var renderFloatingButton = function renderFloatingButton() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-fixed  tw-bottom-1/2 tw-right-0 tw-origin-bottom-right -tw-rotate-90 ",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "tw-flex tw-cursor-pointer tw-items-center tw-gap-[4px] tw-border-none tw-px-[28px] tw-py-[8px] tw-text-[15px]/[20px] tw-font-bold tw-text-white md:tw-py-[12px]  ",
                style: {
                    backgroundColor: themeColor
                },
                onClick: onButtonClick,
                children: [
                    buttonConfig.icon || null,
                    " ",
                    buttonConfig.text
                ]
            })
        });
    };
    var renderDrawerHeader = function renderDrawerHeader() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "tw-sticky tw-top-0 tw-z-50 tw-border-b tw-border-solid tw-border-[#E3E3E3] tw-bg-white",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-flex tw-items-center tw-gap-[12px] tw-px-[20px] tw-py-[32px] tw-text-[18px]/[20px] tw-font-semibold md:tw-px-[24px]",
                    children: [
                        (showCloseIcon !== null && showCloseIcon !== void 0 ? showCloseIcon : true) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "tw-flex tw-cursor-pointer",
                            onClick: onCloseFinal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconBlack/* default */.Z, {
                                size: checkClientDeviceType/* IS_DESKTOP */.yn ? 16 : 12
                            })
                        }),
                        drawerHeading
                    ]
                }),
                additionalHeaderComponent
            ]
        });
    };
    var renderDrawerContent = function renderDrawerContent() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "tw-flex tw-flex-col",
            children: children
        });
    };
    var ref = (0,react.useState)(false), openDrawer = ref[0], setOpenDrawer = ref[1];
    var themeColor = (0,getThemeColor/* getThemeColor */.p)();
    var onCloseDrawer = function() {
        return setOpenDrawer(false);
    };
    var onOpenDrawer = function() {
        return setOpenDrawer(true);
    };
    var showFinal = showDrawer !== null && showDrawer !== void 0 ? showDrawer : openDrawer;
    var onCloseFinal = onClose !== null && onClose !== void 0 ? onClose : onCloseDrawer;
    var _onClick;
    var onButtonClick = (_onClick = buttonConfig.onClick) !== null && _onClick !== void 0 ? _onClick : onOpenDrawer;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderFloatingButton(),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
                open: showFinal,
                onClose: onCloseFinal,
                classes: {
                    paper: checkClientDeviceType/* IS_DESKTOP */.yn ? "tw-w-[40%] tw-min-w-[596px]" : "tw-h-full"
                },
                anchor: checkClientDeviceType/* IS_DESKTOP */.yn ? "right" : "bottom",
                transitionDuration: checkClientDeviceType/* IS_DESKTOP */.yn ? 300 : 400,
                children: [
                    renderDrawerHeader(),
                    renderDrawerContent()
                ]
            })
        ]
    });
};
/* harmony default export */ var components_FloatingButtonAndDrawer = (FloatingButtonAndDrawer);

// EXTERNAL MODULE: ./src/assets/svgExports/OfferIcon.js
var OfferIcon = __webpack_require__(493757);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/TabsContainer/index.tsx
var TabsContainer = __webpack_require__(201325);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/promo.js
var promo = __webpack_require__(168615);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/Common/PromosContainer.tsx
var PromosContainer = __webpack_require__(169708);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/PromosSections/StoreOffersSection.tsx


var StoreOffersSection = function(param) {
    var storePromos = param.storePromos, onPromoClick = param.onPromoClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosContainer/* PromosContainer */.$, {
        promos: storePromos,
        onPromoClick: onPromoClick,
        customClasses: "tw-flex tw-flex-col md:tw-px-[24px] md:tw-py-[21px]",
        primaryTextClasses: "tw-text-[13px]/[18px] tw-font-medium md:tw-text-[16px]/[20px] md:tw-font-semibold",
        secondaryTextClasses: "tw-text-[12px]/[20px] tw-font-normal md:tw-text-[15px]/[20px]"
    });
};
/* harmony default export */ var PromosSections_StoreOffersSection = (StoreOffersSection);

// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/BankOffers/index.tsx
var BankOffers = __webpack_require__(411110);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/PromosSections/BankOffersSection.tsx


var BankOffersSection = function(param) {
    var paymentOffersList = param.paymentOffersList;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BankOffers/* default */.Z, {
        showAllPromos: true,
        paymentOffersList: paymentOffersList,
        isCartPage: false
    });
};
/* harmony default export */ var PromosSections_BankOffersSection = (BankOffersSection);

// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
;// CONCATENATED MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/index.tsx











var PromosDrawerAndButton = function() {
    var getPromos = function getPromos() {
        var data = {
            storeId: storeId,
            userId: userId
        };
        dispatch((0,promo/* getAllPromos */.mv)(data, function(allPromos) {
            return dispatch((0,promo/* saveCouponsList */.Kp)({
                coupons: allPromos
            }));
        }));
        dispatch((0,promo/* getPaymentOffersList */.Xu)(storeId));
    };
    var openPromoModal = function openPromoModal(promoId) {
        dispatch((0,promo/* togglePromoDetailModal */.wl)({
            show: true,
            promoId: promoId
        }));
        checkClientDeviceType/* IS_DESKTOP */.yn && setShowPromos(false);
    };
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref = (0,es/* useSelector */.v9)(function(state) {
        var ref, ref1;
        return {
            storeId: state.storeReducer.store.store_id,
            userId: ((ref = state.userReducer.data) === null || ref === void 0 ? void 0 : ref.user_id) || 0,
            paymentOffersList: state.promoReducer.paymentOffersList || [],
            promos: state === null || state === void 0 ? void 0 : (ref1 = state.promoReducer) === null || ref1 === void 0 ? void 0 : ref1.couponsList
        };
    }), storeId = ref.storeId, userId = ref.userId, paymentOffersList = ref.paymentOffersList, promos = ref.promos;
    var couponsFeatureStatus = (0,useFeatureLocks/* useFeatureLocks */.r)().couponsFeatureStatus;
    var isCouponsFeatureLocked = !!(couponsFeatureStatus === null || couponsFeatureStatus === void 0 ? void 0 : couponsFeatureStatus.isLocked);
    var ref1 = (0,react.useState)(0), activeTabIndex = ref1[0], setActiveTabIndex = ref1[1];
    var ref2 = (0,react.useState)(false), showPromos = ref2[0], setShowPromos = ref2[1];
    var tabsData = [
        {
            text: "Store Offers"
        },
        {
            text: "Bank Offers"
        }, 
    ];
    (0,react.useEffect)(function() {
        if (storeId && !isCouponsFeatureLocked && !promos.length) {
            getPromos();
        }
    }, [
        storeId,
        isCouponsFeatureLocked
    ]);
    var showStoreOffers = activeTabIndex === 0;
    return !isCouponsFeatureLocked && !!promos.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FloatingButtonAndDrawer, {
            buttonConfig: {
                text: "Offers",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(OfferIcon/* default */.Z, {}),
                onClick: function() {
                    return setShowPromos(true);
                }
            },
            showDrawer: showPromos,
            onClose: function() {
                return setShowPromos(false);
            },
            drawerHeading: "Offers",
            additionalHeaderComponent: !!(paymentOffersList === null || paymentOffersList === void 0 ? void 0 : paymentOffersList.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsContainer/* default */.Z, {
                activeTabIndex: activeTabIndex,
                setActiveTabIndex: setActiveTabIndex,
                tabsData: tabsData,
                tabClasses: "!tw-text-[14px]/[20px] md:!tw-text-[18px]/[20px] !tw-px-[20px] md:!tw-px-[32px] tw-pb-[18px]"
            }),
            children: showStoreOffers ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosSections_StoreOffersSection, {
                storePromos: promos,
                onPromoClick: openPromoModal
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosSections_BankOffersSection, {
                paymentOffersList: paymentOffersList
            })
        })
    });
};
/* harmony default export */ var CouponsAndVouchers_PromosDrawerAndButton = (PromosDrawerAndButton);


/***/ }),

/***/ 379062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(307297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(667294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(150066);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  0% {\n    transform: translateX(-100%);\n  }\n  100% {\n    transform: translateX(100%);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  overflow: hidden;\n  background: #eee;\n\n  &::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(\n      90deg,\n      transparent,\n      rgba(255, 255, 255, 0.6),\n      transparent\n    );\n    animation: ",
        " 1.5s infinite;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  border-radius: 10px;\n  margin-bottom: 25px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: 6px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  gap: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



var CardSkeleton = function(param) {
    var _type = param.type, type = _type === void 0 ? "product" : _type, customStyles = param.customStyles;
    if (type === "product") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SkeletonContainer, {
            customStyles: customStyles,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ImagePlaceholder, {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RowGroup, {
                    className: "tw-mb-8",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "60px",
                            height: "27px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "40px",
                            height: "27px"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(RowGroup, {
                    className: "tw-flex-col tw-gap-4",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "100%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "50%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "60%",
                            height: "14px"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Row, {
                            width: "90%",
                            height: "14px"
                        })
                    ]
                })
            ]
        });
    }
    return null;
};
/* harmony default export */ __webpack_exports__["Z"] = (CardSkeleton);
var shimmer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .keyframes */ .F4)(_templateObject());
var ShimmerWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ShimmerWrapper",
    componentId: "sc-95c11a38-0"
})(_templateObject1(), shimmer);
var SkeletonContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "SkeletonContainer",
    componentId: "sc-95c11a38-1"
})(_templateObject2(), function(props) {
    var ref;
    return ((ref = props.customStyles) === null || ref === void 0 ? void 0 : ref.width) || "100%";
});
var ImagePlaceholder = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ShimmerWrapper).withConfig({
    displayName: "ImagePlaceholder",
    componentId: "sc-95c11a38-2"
})(_templateObject3());
var Row = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(ShimmerWrapper).withConfig({
    displayName: "Row",
    componentId: "sc-95c11a38-3"
})(_templateObject4(), function(props) {
    return props.width;
}, function(props) {
    return props.height || "20px";
});
var RowGroup = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "RowGroup",
    componentId: "sc-95c11a38-4"
})(_templateObject5());


/***/ }),

/***/ 639996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ ProductListWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/hooks/useGetDeviceType.tsx
var useGetDeviceType = __webpack_require__(662946);
// EXTERNAL MODULE: ./src/hooks/useItemClick.js + 1 modules
var useItemClick = __webpack_require__(780058);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts
var WidgetDndContext = __webpack_require__(474151);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductCard/utils.tsx + 1 modules
var utils = __webpack_require__(881241);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/WIdgetPropertiesBasic/components/Snackbar/Snackbar.tsx
var Snackbar = __webpack_require__(185810);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/utils.ts
var ProductListWrapper_utils = __webpack_require__(202386);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(999534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(629815);
// EXTERNAL MODULE: ./node_modules/react-virtuoso/dist/index.mjs
var dist = __webpack_require__(826246);
// EXTERNAL MODULE: ./node_modules/lodash/cloneDeep.js
var cloneDeep = __webpack_require__(150361);
var cloneDeep_default = /*#__PURE__*/__webpack_require__.n(cloneDeep);
// EXTERNAL MODULE: ./src/components/DesignSystem/Card/CardSkeleton.tsx
var CardSkeleton = __webpack_require__(379062);
// EXTERNAL MODULE: ./src/components/VirtualisedList/utils.ts
var VirtualisedList_utils = __webpack_require__(602641);
;// CONCATENATED MODULE: ./src/components/VirtualisedList/index.tsx










var INCREASE_VIEWPORT_BY = 0;
/**
 * the main idea behind this component is to treat the rows as ->
 * 1. `components` - which will have full width and can be changed to any component like heading.
 * 2. `sliced-flex-cards` - which is a flex row containing product cards.
 */ // eslint-disable-next-line react/display-name
var VirtualisedGridList = /*#__PURE__*/ (0,react.memo)(/*#__PURE__*/ (0,react.forwardRef)(function(param, virtualisedGridListReference) {
    var listData = param.listData, renderProductCard = param.renderProductCard, itemsRenderConfig = param.itemsRenderConfig, virtualisationContainerStyle = param.virtualisationContainerStyle, _useWindowScroll = param.useWindowScroll, useWindowScroll = _useWindowScroll === void 0 ? true : _useWindowScroll, defaultItemHeight = param.defaultItemHeight;
    var generateCardRows = /**
       * takes a list of card items and convert then into groups of cards to render in each row.
       * number of items in each row is defined by `itemsRenderConfig.columnCount`,
       */ function generateCardRows(indexedListData, index) {
        var ref;
        var resultantPageData = [];
        var rowData = [];
        while(isItemCardType((ref = indexedListData[index]) === null || ref === void 0 ? void 0 : ref.type)){
            var rowId = "".concat(index);
            for(var rowItems = 0; rowItems < itemsRenderConfig.columnCount; rowItems++){
                if (!indexedListData[index]) {
                    break;
                }
                if (isItemCardType(indexedListData[index].type)) {
                    rowData.push(indexedListData[index]);
                    rowId = "".concat(rowId, "-").concat(indexedListData[index].id);
                    index += 1;
                } else {
                    break;
                }
            }
            resultantPageData.push({
                type: "sliced-flex-cards",
                data: rowData,
                id: rowId
            });
            rowData = [];
        }
        return {
            cardRows: resultantPageData,
            updatedIndex: index
        };
    };
    var virtuosoGridRef = (0,react.useRef)(null);
    /**
       * to track previous value of range.
       * keys can have any value (just to maintain an entry).
       * this will help in reducing calls for `intersectionCallback`
       * check implementation of `handleRangeChanged`
       */ var rowChangeTrackerRef = (0,react.useRef)({});
    var isItemCardType = function(itemType) {
        return itemType === "product-card" || itemType === "product-card-skeleton";
    };
    /**
       * NOTE:- any operation on this page will now be done on slicedItems (unless there is a very specific need)
       * converting a list of items whose types are defined in `ItemTypes` to renderable format.
       *
       * ## representing items by type
       * eg. ["component", "product-card", "product-card","product-card","product-card","product-card","product-card"]
       * lets say `itemsRenderConfig.columnCount` = 3
       * [
       *    "component",
       *    "sliced-flex-cards": ["product-card", "product-card","product-card"],
       *    "sliced-flex-cards": ["product-card", "product-card","product-card"],
       * ]
       *
       * this function treats `product-card` and `product-card-skeleton` as similar objects.
       * to add/remove skeleton loaders, we need to add/remove them from listData
       */ var slicedItems = (0,react.useMemo)(function() {
        var resultantPageData = [];
        var indexedListData = listData === null || listData === void 0 ? void 0 : listData.map(function(item, idx) {
            // indexedListData will have an index key for every item so that the items can be tracked after shuffling in slicing phase
            item.index = idx;
            return item;
        });
        for(var index = 0; index < (indexedListData === null || indexedListData === void 0 ? void 0 : indexedListData.length); index++){
            // whenever a card is found, make sets of cards for rendering in a row
            if (isItemCardType(indexedListData[index].type)) {
                var cardRowsObj = generateCardRows(indexedListData, index);
                index = cardRowsObj.updatedIndex;
                resultantPageData = (0,_to_consumable_array/* default */.Z)(resultantPageData || []).concat((0,_to_consumable_array/* default */.Z)(cardRowsObj.cardRows || []));
            }
            resultantPageData.push(indexedListData[index]);
        }
        return resultantPageData;
    }, [
        listData
    ]);
    // extracting the `scrollToIndex` from Virtuoso component and exposing it to parent for the auto scroll functionality
    (0,react.useImperativeHandle)(virtualisedGridListReference, function() {
        return {
            scrollToIndex: handleScrollToIndex
        };
    });
    /**
       * since every row is either a `sliced-flex-cards` or a `component`,
       * we calculate the index where an element to scroll is lying after converting to sliced flex.
       */ var handleScrollToIndex = function(indexToScroll) {
        var _loop = function(index) {
            var item = slicedItems[index];
            if ((item === null || item === void 0 ? void 0 : item.type) === "sliced-flex-cards") {
                var ref;
                (ref = item === null || item === void 0 ? void 0 : item.data) === null || ref === void 0 ? void 0 : ref.forEach(function(sliceItem) {
                    if (sliceItem.index === indexToScroll) {
                        idexToScrollAfterSlicing = index;
                    }
                });
            } else {
                if (indexToScroll === (item === null || item === void 0 ? void 0 : item.index)) {
                    idexToScrollAfterSlicing = index;
                }
            }
        };
        var idexToScrollAfterSlicing = undefined;
        for(var index = 0; index <= (slicedItems === null || slicedItems === void 0 ? void 0 : slicedItems.length); index++)_loop(index);
        if (idexToScrollAfterSlicing || idexToScrollAfterSlicing === 0) {
            var // offset to place scrolled item in center
            ref, ref1;
            virtuosoGridRef === null || virtuosoGridRef === void 0 ? void 0 : (ref = virtuosoGridRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.scrollToIndex) === null || ref1 === void 0 ? void 0 : ref1.call(ref, {
                index: idexToScrollAfterSlicing,
                align: "center",
                offset: 200
            });
        }
    };
    var handleRangeChanged = function(range) {
        var previousRange = cloneDeep_default()(rowChangeTrackerRef.current);
        var newRange = {};
        var startIndex = range === null || range === void 0 ? void 0 : range.startIndex;
        var endIndex = range === null || range === void 0 ? void 0 : range.endIndex;
        for(var index = startIndex; index <= endIndex; index++){
            // track all indexes currently on screen
            newRange[index] = 1;
            // exclude intersection callback if index present in previous row change
            if (previousRange[index]) {
                continue;
            }
            var item = slicedItems === null || slicedItems === void 0 ? void 0 : slicedItems[index];
            if (!item) {
                break;
            }
            if (item.type === "sliced-flex-cards") {
                var ref;
                (ref = item === null || item === void 0 ? void 0 : item.data) === null || ref === void 0 ? void 0 : ref.forEach(function(element) {
                    var ref;
                    element === null || element === void 0 ? void 0 : (ref = element.intersectionCallback) === null || ref === void 0 ? void 0 : ref.call(element);
                });
            } else {
                var ref1;
                item === null || item === void 0 ? void 0 : (ref1 = item.intersectionCallback) === null || ref1 === void 0 ? void 0 : ref1.call(item);
            }
        }
        rowChangeTrackerRef.current = newRange;
    };
    var renderItemContent = (0,react.useCallback)(function(index, listItem) {
        if ((listItem === null || listItem === void 0 ? void 0 : listItem.type) === "component") {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(listItem.Component, {});
        } else if ((listItem === null || listItem === void 0 ? void 0 : listItem.type) === "sliced-flex-cards") {
            var ref;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    columnGap: itemsRenderConfig.columnGap,
                    margin: "".concat(itemsRenderConfig.rowGap, "px 0")
                },
                className: "tw-flex tw-flex-row tw-items-start tw-justify-start",
                children: listItem === null || listItem === void 0 ? void 0 : (ref = listItem.data) === null || ref === void 0 ? void 0 : ref.map(function(item, idx) {
                    if ((item === null || item === void 0 ? void 0 : item.type) === "product-card") {
                        return renderProductCard(item === null || item === void 0 ? void 0 : item.index, item === null || item === void 0 ? void 0 : item.data);
                    } else if ((item === null || item === void 0 ? void 0 : item.type) === "product-card-skeleton") {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSkeleton/* default */.Z, {}, idx);
                    }
                })
            });
        }
    }, [
        slicedItems
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* Virtuoso */.OO, {
        useWindowScroll: useWindowScroll,
        ref: virtuosoGridRef,
        rangeChanged: handleRangeChanged,
        increaseViewportBy: INCREASE_VIEWPORT_BY,
        data: slicedItems,
        defaultItemHeight: defaultItemHeight || 400,
        itemContent: renderItemContent,
        components: {
            Item: function(_param) {
                var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
                    "children"
                ]);
                var itemIndex = props === null || props === void 0 ? void 0 : props["data-index"];
                var correspondingItem = slicedItems === null || slicedItems === void 0 ? void 0 : slicedItems[itemIndex];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    // Just to remove an error due zero element height in the internal working of virtuoso
                    style: {
                        minHeight: "1px"
                    },
                    children: children
                }), correspondingItem === null || correspondingItem === void 0 ? void 0 : correspondingItem.id);
            },
            // eslint-disable-next-line react/display-name
            List: /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
                var style = _param.style, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
                    "style",
                    "children"
                ]);
                return (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: ref
                }, props), {
                    style: (0,_object_spread/* default */.Z)({}, style, virtualisationContainerStyle),
                    children: children
                }));
            })
        }
    });
}), VirtualisedList_utils/* compareListData */.T);
VirtualisedGridList.displayName = "VirtualisedGridList";
/* harmony default export */ var VirtualisedList = (VirtualisedGridList);

// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/ProductListWrapper.tsx

















var MobileDsAds = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7198), __webpack_require__.e(6778)]).then(__webpack_require__.bind(__webpack_require__, 77198)).then(function(mod) {
        return mod.MobileDsAds;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77198)
            ];
        }
    },
    ssr: false
});
var Card = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(258), __webpack_require__.e(3548)]).then(__webpack_require__.bind(__webpack_require__, 950258)).then(function(mod) {
        return mod.Card;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(950258)
            ];
        }
    }
});
var ProductCard = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(437), __webpack_require__.e(9719), __webpack_require__.e(6499), __webpack_require__.e(2287), __webpack_require__.e(4505), __webpack_require__.e(2755), __webpack_require__.e(2285)]).then(__webpack_require__.bind(__webpack_require__, 632755)).then(function(mod) {
        return mod.ProductCard;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(632755)
            ];
        }
    }
});
var AdvanceCard = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5195).then(__webpack_require__.bind(__webpack_require__, 185195)).then(function(mod) {
        return mod.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(185195)
            ];
        }
    }
});
// Product list is put got like this to get category wise data etc.
// eslint-disable-next-line react/display-name
var ProductListWrapper = /*#__PURE__*/ (0,react.forwardRef)(function(param, productListWrapperReference) {
    var _children = param.children, children = _children === void 0 ? null : _children, tmp = param.productList, passedProductList = tmp === void 0 ? [] : tmp, _oldCardConfigs = param.oldCardConfigs, oldCardConfigs = _oldCardConfigs === void 0 ? {
        showButton: true,
        noTags: false,
        showCategoryCard: false,
        noTagsReadState: "fromProp",
        isWishlistCard: false,
        onWishlistDeleteClick: undefined
    } : _oldCardConfigs, _hideLoaderSkeleton = param.hideLoaderSkeleton, hideLoaderSkeleton = _hideLoaderSkeleton === void 0 ? false : _hideLoaderSkeleton, _skeletonCount = param.skeletonCount, skeletonCount = _skeletonCount === void 0 ? 3 : _skeletonCount, _overrideGlobalBuilderProductCard = param.overrideGlobalBuilderProductCard, overrideGlobalBuilderProductCard = _overrideGlobalBuilderProductCard === void 0 ? false : _overrideGlobalBuilderProductCard, _renderAdvancedCard = param.renderAdvancedCard, renderAdvancedCard = _renderAdvancedCard === void 0 ? false : _renderAdvancedCard, _CustomCardComponent = param.CustomCardComponent, CustomCardComponent = _CustomCardComponent === void 0 ? null : _CustomCardComponent, customClass = param.customClass, _calculateSelfDimensions = param.calculateSelfDimensions, calculateSelfDimensions = _calculateSelfDimensions === void 0 ? false : _calculateSelfDimensions, _renderType = param.renderType, renderType = _renderType === void 0 ? "grid" : _renderType;
    var ref;
    var ref1 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), _widgetContextState = ref1.widgetContextState, isBuilder = _widgetContextState.isBuilder, previewDevice = _widgetContextState.previewDevice;
    var storeData = (0,redux/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var ref2 = (0,ProductListWrapper_utils/* useProductCardElements */.S3)(), layoutElement = ref2.layoutElement, infoList = ref2.infoList, isProductCardEnabled = ref2.isProductCardEnabled;
    var showCustomProductCard = isProductCardEnabled && (infoList === null || infoList === void 0 ? void 0 : infoList.length) && !overrideGlobalBuilderProductCard ? true : false;
    var layoutElementConfig = layoutElement === null || layoutElement === void 0 ? void 0 : layoutElement.config;
    var cardWrapperConfigs = (0,utils/* getCartWrapperConfigs */.Ui)(layoutElementConfig);
    var productItemContainerRef = (0,react.useRef)(null);
    var virtuosoGridRef = (0,react.useRef)(null);
    var deviceType = (0,useGetDeviceType/* useGetDeviceType */.n)().deviceType;
    var isMobile = (isBuilder ? previewDevice === "mobile" : false) || deviceType === "mobile";
    var ref3 = (0,react.useState)({
        containerWidth: 0
    }), listDimensions = ref3[0], setListDimensions = ref3[1];
    var productList = (0,react.useMemo)(function() {
        if (!Array.isArray(passedProductList) || !(passedProductList === null || passedProductList === void 0 ? void 0 : passedProductList.length)) return [];
        if (renderType === "virtualised-grid") return passedProductList;
        return passedProductList.filter(function(data) {
            var ref;
            return data.is_active === constants/* ITEM_ACTIVE_STATUS.ACTIVE */.p4.ACTIVE && (!(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.hide_out_of_stock) || (data === null || data === void 0 ? void 0 : data.available));
        });
    }, [
        passedProductList,
        passedProductList === null || passedProductList === void 0 ? void 0 : passedProductList.length,
        storeData === null || storeData === void 0 ? void 0 : (ref = storeData.services) === null || ref === void 0 ? void 0 : ref.hide_out_of_stock, 
    ]);
    var columnsMobile = (layoutElementConfig === null || layoutElementConfig === void 0 ? void 0 : layoutElementConfig.numColumnsMobile) || 2;
    var coumnsDesktop = (layoutElementConfig === null || layoutElementConfig === void 0 ? void 0 : layoutElementConfig.numColumnsDesktop) || 3;
    var gaps = (0,ProductListWrapper_utils/* calculateLayoutGap */.eH)({
        showCustomProductCard: showCustomProductCard,
        cardWrapperConfigs: cardWrapperConfigs,
        isMobile: isMobile
    });
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useItemClick/* useItemClick */.M)(), 1), onItemClick = ref4[0];
    var columnNum = isMobile ? columnsMobile : coumnsDesktop;
    var OldCardComponent = CustomCardComponent || (!renderAdvancedCard ? Card : AdvanceCard);
    var ref5 = (0,react.useState)({
        open: false,
        message: ""
    }), snackbarConfig = ref5[0], setSnackbarConfig = ref5[1];
    var showVirtualisedList = renderType === "virtualised-grid";
    // extracting the `scrollToIndex` from Virtuoso component and exposing it to parent for the auto scroll functionality
    (0,react.useImperativeHandle)(productListWrapperReference, function() {
        return {
            scrollToIndex: function(index) {
                var ref, ref1;
                return virtuosoGridRef === null || virtuosoGridRef === void 0 ? void 0 : (ref = virtuosoGridRef.current) === null || ref === void 0 ? void 0 : (ref1 = ref.scrollToIndex) === null || ref1 === void 0 ? void 0 : ref1.call(ref, index);
            }
        };
    });
    (0,react.useEffect)(function() {
        var updateDimensions = function updateDimensions() {
            var ref;
            var sectionWidth = (ref = productItemContainerRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth;
            if (sectionWidth) {
                setListDimensions(function(items) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, items), {
                        containerWidth: sectionWidth
                    });
                });
            }
        };
        var resObserver = new ResizeObserver(updateDimensions);
        productItemContainerRef.current && resObserver.observe(productItemContainerRef.current);
        updateDimensions();
        return function() {
            productItemContainerRef.current && resObserver.unobserve(productItemContainerRef.current);
        };
    }, []);
    // This is the padding that is added in the card when images is rendered in the card with padding
    // Horizontal Padding is added i.e. 10(leftPad) & 10(rightPad) = 20, will be removed from calculated
    // Image width will be minus these
    var cardWithMarginDimensions = cardWrapperConfigs.isCardLayout && !cardWrapperConfigs.isFullWidth ? isMobile ? 20 : 28 : 0;
    var imageWidth = function() {
        var totalGapWidth = (columnNum - (!isMobile ? 1 : 0)) * gaps.columnGap;
        var oneCardWidth = (listDimensions.containerWidth - totalGapWidth) / columnNum;
        // If not card with padding, then oneCardWidth is same as oneImageWidth
        var oneImgWidth = oneCardWidth - cardWithMarginDimensions;
        return oneImgWidth;
    }();
    var cardSelfDimensions = (0,ProductListWrapper_utils/* useProductCardDimensions */.lT)({
        imageWidth: imageWidth
    }).cardSelfDimensions;
    var cardWidth = cardSelfDimensions.cardWidth + cardWithMarginDimensions;
    // const canFitColumns = cardWidth * columnNum <= listDimensions.containerWidth;
    var canFitColumns = cardWidth - gaps.rowGap * columnNum <= listDimensions.containerWidth;
    var snackbarMethods = {
        openSnackbar: function(config) {
            return setSnackbarConfig((0,_object_spread/* default */.Z)({
                open: true
            }, config));
        },
        hideSnackbar: function() {
            return snackbarConfig.open && setSnackbarConfig(function(data) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                    open: false
                });
            });
        }
    };
    var renderProductCard = (0,react.useCallback)(function(index, listItem) {
        var data = listItem;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: {
                maxWidth: cardWidth,
                width: cardWidth
            },
            children: [
                showCustomProductCard && !(oldCardConfigs === null || oldCardConfigs === void 0 ? void 0 : oldCardConfigs.isWishlistCard) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard, {
                    productData: data,
                    itemIndex: index,
                    onItemClick: onItemClick,
                    configs: {
                        cardWrapperConfigs: cardWrapperConfigs,
                        isMobile: isMobile,
                        dimensions: cardSelfDimensions,
                        snackbarMethods: snackbarMethods
                    }
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(OldCardComponent, (0,_object_spread/* default */.Z)({
                    data: data,
                    id: "".concat(data.name, "-").concat(data.id),
                    onItemClick: function() {
                        return onItemClick(data);
                    }
                }, oldCardConfigs)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileDsAds, {
                    data: data
                })
            ]
        }, "items-card-" + data.id);
    }, [
        cardSelfDimensions
    ]);
    if (showVirtualisedList) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            ref: productItemContainerRef,
            className: "tw-h-full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VirtualisedList, {
                ref: virtuosoGridRef,
                useWindowScroll: !isBuilder,
                listData: productList,
                renderProductCard: renderProductCard,
                virtualisationContainerStyle: {},
                itemsRenderConfig: {
                    columnCount: canFitColumns ? columnNum : columnNum - 1,
                    columnGap: gaps.columnGap,
                    rowGap: gaps.rowGap
                }
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
        ref: productItemContainerRef,
        className: classnames_default()("newProductListingWrapper ", renderType === "grid" ? "tw-grid tw-justify-center tw-justify-items-center" : "no-scrollbar tw-flex tw-overflow-auto", customClass),
        style: {
            gridTemplateColumns: "repeat(".concat(canFitColumns ? columnNum : columnNum - 1, ", ").concat(isMobile ? cardWidth > 0 ? "minmax(10px, ".concat(cardWidth, "px)") : "1fr" : "minmax(10px, ".concat(showCustomProductCard || calculateSelfDimensions ? cardWidth : 220, "px)"), ")"),
            columnGap: "".concat(gaps.columnGap, "px"),
            rowGap: "".concat(gaps.rowGap, "px")
        },
        children: [
            (productList === null || productList === void 0 ? void 0 : productList.length) ? productList.map(function(data, index) {
                return renderProductCard(index, data);
            }) : !hideLoaderSkeleton && !!skeletonCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: new Array(skeletonCount).fill(0).map(function(_, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardSkeleton/* default */.Z, {}, index);
                })
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Snackbar/* CustomizedSnackbar */.y, {
                config: (0,_object_spread/* default */.Z)({}, snackbarConfig),
                handleSnackbarClose: function() {
                    return setSnackbarConfig(function(x) {
                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, x), {
                            open: false
                        });
                    });
                }
            })
        ]
    });
});


/***/ }),

/***/ 202386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S3": function() { return /* binding */ useProductCardElements; },
/* harmony export */   "eH": function() { return /* binding */ calculateLayoutGap; },
/* harmony export */   "lT": function() { return /* binding */ useProductCardDimensions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(269396);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(667294);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(474151);




var MAX_CARD_WIDTH = 450;
// const MIN_CARD_WIDTH = 200;
var MAX_CARD_HEIGHT = 450;
function useProductCardElements() {
    var ref, ref1;
    var ref2 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_1__/* .useWidgetDndContextData */ .KX)(), globalStyle = ref2.widgetContextState.globalStyle;
    var ref3 = (globalStyle === null || globalStyle === void 0 ? void 0 : globalStyle.productCard) || {
        infoList: [],
        isEnabled: false
    }, infoList = ref3.infoList, isProductCardEnabled = ref3.isEnabled;
    var imageElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
        return item.type === "image";
    });
    var layoutElement = infoList === null || infoList === void 0 ? void 0 : infoList.find(function(item) {
        return item.type === "layout";
    });
    return {
        isProductCardEnabled: isProductCardEnabled,
        layoutElement: layoutElement,
        imageElement: imageElement,
        infoList: infoList,
        aspectRatio: (imageElement === null || imageElement === void 0 ? void 0 : (ref = imageElement.config) === null || ref === void 0 ? void 0 : ref.aspectRatio) || (imageElement === null || imageElement === void 0 ? void 0 : (ref1 = imageElement.config) === null || ref1 === void 0 ? void 0 : ref1.aspectRation)
    };
}
function useProductCardDimensions(param) {
    var imageWidth = param.imageWidth;
    var aspectRatio = useProductCardElements().aspectRatio;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        cardHeight: 0,
        cardWidth: 0
    }), cardSelfDimensions = ref[0], setCardSelfDimensions = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (aspectRatio) {
            var aspectRatios = function() {
                var ratio = (aspectRatio === null || aspectRatio === void 0 ? void 0 : aspectRatio.split(":")) || [
                    1,
                    1
                ];
                return {
                    heightMultiplier: +ratio[1],
                    widthMultiplier: +ratio[0]
                };
            }();
            if (imageWidth) {
                var calculatedCardWidth = imageWidth > MAX_CARD_WIDTH ? MAX_CARD_WIDTH : //   ? MIN_CARD_WIDTH
                imageWidth;
                var calculatedCardHeight = calculatedCardWidth * (aspectRatios.heightMultiplier / aspectRatios.widthMultiplier);
                if (calculatedCardHeight > MAX_CARD_HEIGHT) {
                    calculatedCardHeight = MAX_CARD_HEIGHT;
                    calculatedCardWidth = calculatedCardHeight * (aspectRatios.widthMultiplier / aspectRatios.heightMultiplier);
                }
                setCardSelfDimensions(function(data) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, data), {
                        cardWidth: calculatedCardWidth,
                        cardHeight: calculatedCardHeight
                    });
                });
            }
        }
    }, [
        imageWidth,
        aspectRatio
    ]);
    return {
        cardSelfDimensions: cardSelfDimensions
    };
}
var calculateLayoutGap = function(param) {
    var showCustomProductCard = param.showCustomProductCard, cardWrapperConfigs = param.cardWrapperConfigs, isMobile = param.isMobile;
    var gap = {
        columnGap: 20,
        rowGap: 30
    };
    if (!showCustomProductCard) return gap;
    if (!isMobile && !cardWrapperConfigs.isCardLayout) {
        gap.columnGap = 28;
        gap.rowGap = 52;
        return gap;
    }
    if (!isMobile && cardWrapperConfigs.isCardLayout) {
        gap.columnGap = 16;
        gap.rowGap = 16;
        return gap;
    }
    if (isMobile && !cardWrapperConfigs.isCardLayout) {
        gap.columnGap = 16;
        gap.rowGap = 32;
        return gap;
    }
    gap.columnGap = 8;
    gap.rowGap = 8;
    return gap;
};


/***/ }),

/***/ 315241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ FullPageLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(179220);
/* harmony import */ var src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(474151);



// import interLoader from '../../../public/assets/images/inter-loader.gif';


function FullPageLoader() {
    var ref, ref1;
    var ref2 = (0,src_context_WidgetDndContext__WEBPACK_IMPORTED_MODULE_4__/* .useWidgetDndContextData */ .KX)(), globalStyle = ref2.widgetContextState.globalStyle;
    var globalLoader = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return {
            globalLoader: state.commonReducer.globalLoader
        };
    }).globalLoader;
    return globalLoader && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "global-loader",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_WidgetMaker_WidgetDnD_GlobalCfeLoader__WEBPACK_IMPORTED_MODULE_3__/* .GlobalCfeLoader */ .I, {
            type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref = globalStyle.appLoader) === null || ref === void 0 ? void 0 : ref.loaderId) || "ellipsis",
            color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.color
        })
    });
}


/***/ }),

/***/ 932948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(225617);
/* harmony import */ var _components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(452388);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(731024);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96031);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(666162);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(672651);
/* harmony import */ var _utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(759186);









var VariantChooseRepeatModal = function(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        repeatIndex: null,
        theme: null
    }), state = ref14[0], setState = ref14[1];
    var ref15 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.commonReducer;
    }), chooseRepeatModal = ref15.variant.chooseRepeatModal, productLoaderId = ref15.productLoaderId;
    var cartData = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.cartReducer;
    });
    var ref16 = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    }), theme = ref16.theme, store_id = ref16.store_id;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (chooseRepeatModal) {
            var productIndex = cartData.items.findIndex(function(el) {
                return el.id === productLoaderId;
            });
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                    repeatIndex: productIndex
                });
            });
        }
    }, [
        chooseRepeatModal,
        cartData,
        productLoaderId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (chooseRepeatModal) {
            setState(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, state), {
                    theme: theme
                });
            });
        }
    }, [
        chooseRepeatModal,
        theme
    ]);
    var onClose = function() {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_7__/* .setChooseAndRepeatModalVisibility */ .uT)(false));
    };
    var onIWillChooseBtnHandle = function() {
        /** get the details item for this item id */ dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_8__/* .fetchCatalogItemById */ .eP)({
            store_id: store_id,
            item_id: productLoaderId,
            src: "variant_choose_repeat_modal"
        }, true));
        onClose();
    };
    var onRepeatBtnHandle = function() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var newCart = (0,_utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_4__/* .mutateVariantItemWithCartData */ .I)("repeat", cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref[state.repeatIndex], cartData === null || cartData === void 0 ? void 0 : (ref1 = cartData.items) === null || ref1 === void 0 ? void 0 : (ref2 = ref1[state.repeatIndex]) === null || ref2 === void 0 ? void 0 : ref2.variants_selected[(cartData === null || cartData === void 0 ? void 0 : (ref3 = cartData.items) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[state.repeatIndex]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.variants_selected) === null || ref5 === void 0 ? void 0 : ref5.length) - 1], cartData);
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_9__/* .saveCart */ .FP)(newCart));
        onClose();
    };
    return chooseRepeatModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Common_Modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        visible: chooseRepeatModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0
        },
        height: "auto",
        animation: "slideUp",
        className: "bottom-modal variantChooseRepeatModal",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "closeicon",
                onClick: onClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    loading: "lazy",
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                    alt: "cancel"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "title",
                children: "Choose a Variant"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "sub-title",
                children: "Your Last Choice"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("article", {
                className: "variant-name",
                children: (ref5 = cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[state.repeatIndex]) === null || ref1 === void 0 ? void 0 : ref1.variants_selected[(cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[state.repeatIndex]) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.variants_selected) === null || ref4 === void 0 ? void 0 : ref4.length) - 1]) === null || ref5 === void 0 ? void 0 : ref5.variant_name
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "footer",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "choose_btn pointer",
                        style: {
                            borderRadius: "".concat(state.theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__/* .roundnessCalculator */ .M)((ref6 = state.theme) === null || ref6 === void 0 ? void 0 : ref6.roundness)) : "8px"),
                            borderColor: "".concat(state.theme ? (ref7 = state.theme) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.colors) === null || ref8 === void 0 ? void 0 : ref8.primary_color : "#EA5151"),
                            color: "".concat(state.theme ? (ref9 = state.theme) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.colors) === null || ref10 === void 0 ? void 0 : ref10.primary_color : "#EA5151")
                        },
                        onClick: onIWillChooseBtnHandle,
                        children: "I’LL CHOOSE"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "repeat_btn pointer",
                        style: {
                            backgroundColor: "".concat(state.theme ? (ref11 = state.theme) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.colors) === null || ref12 === void 0 ? void 0 : ref12.primary_color : "#EA5151"),
                            borderRadius: "".concat(state.theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_10__/* .roundnessCalculator */ .M)((ref13 = state.theme) === null || ref13 === void 0 ? void 0 : ref13.roundness)) : "8px"),
                            color: "#ffffff"
                        },
                        onClick: onRepeatBtnHandle,
                        children: "REPEAT"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VariantChooseRepeatModal);


/***/ }),

/***/ 740261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _Common_Modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(672651);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186812);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(225617);
/* harmony import */ var _components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(452388);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(96031);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(731024);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(666162);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(467936);
/* harmony import */ var _VariantRadioGroup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(916873);
/* harmony import */ var _utils_selectedVariantFromVariantList__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(982983);
/* harmony import */ var _utils_itemIndexFromCart__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(648670);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(540190);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Common_Toast__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40804);
/* harmony import */ var _DesignSystem_AtomicComponents__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(438855);
/* harmony import */ var _DesignSystem_AtomicComponents_CartButton_CartButton_styles__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(151592);
/* harmony import */ var _assets_svgExports_MinusIcon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(282513);
/* harmony import */ var _assets_svgExports_PlusIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(408886);
/* harmony import */ var _utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(336623);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(913886);
/* harmony import */ var _utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(759186);
/* harmony import */ var _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(644779);
/* harmony import */ var _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(506337);
/* harmony import */ var _hooks_useCartHandler__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(491240);

























var VariantModal = function(props) {
    var ref, ref1, ref2, ref3;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        variantIndex: -1,
        variantId: -1
    }), activeVariant = ref4[0], setActiveVariant = ref4[1];
    var ref5 = (0,_hooks_useCartHandler__WEBPACK_IMPORTED_MODULE_18__/* .useCartHandlers */ .u)(), handleIncreamentClick = ref5.handleIncreamentClick, handleDecreamentClick = ref5.handleDecreamentClick, handleSetProductData = ref5.handleSetProductData, handleSetState = ref5.handleSetState, onPersonalizeProductClick = ref5.onPersonalizeProductClick, handleSetProductCustomizationCount = ref5.handleSetProductCustomizationCount;
    /*
   state created to handle cart changes that are not saved.
   for eg, if user adds quantity of variant but does't save the change/ add to cart,
   then global cart data will not get changed
   */ var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}), localCartData = ref6[0], setLocalCartData = ref6[1];
    var ref7 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.storeReducer.store;
    }), store_info = ref7.store_info, theme = ref7.theme, store_id = ref7.store_id;
    var ref8 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return {
            userData: state.userReducer,
            storeInfo: state.storeReducer.store,
            cartData: state.cartReducer
        };
    }), userData = ref8.userData, storeInfo = ref8.storeInfo, cartData = ref8.cartData;
    var ref9 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state.commonReducer;
    }), variantModal = ref9.variant.variantModal, detailedItem = ref9.detailedItem, productLoaderId = ref9.productLoaderId;
    /*
    below useEffect is for saving index and id of first available
    variant of the specific item
  */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (variantModal && detailedItem) {
            var ref;
            var activeVariantIndex = detailedItem === null || detailedItem === void 0 ? void 0 : (ref = detailedItem.variants) === null || ref === void 0 ? void 0 : ref.findIndex(function(el) {
                return el.available === 1 && el.status !== 2;
            });
            var ref1;
            setActiveVariant(function(state) {
                var ref, ref2;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, state), {
                    variantIndex: activeVariantIndex,
                    variantId: (ref1 = detailedItem === null || detailedItem === void 0 ? void 0 : (ref = detailedItem.variants) === null || ref === void 0 ? void 0 : (ref2 = ref[activeVariantIndex]) === null || ref2 === void 0 ? void 0 : ref2.variant_id) !== null && ref1 !== void 0 ? ref1 : -1
                });
            });
            handleSetState === null || handleSetState === void 0 ? void 0 : handleSetState(activeVariantIndex);
            // store cartData in local state
            if (cartData) {
                setLocalCartData(cartData);
            }
        }
    }, [
        variantModal,
        detailedItem
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (variantModal && detailedItem === null) {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_21__/* .fetchCatalogItemById */ .eP)({
                store_id: store_id,
                item_id: productLoaderId,
                src: "variant_modal"
            }, true));
        }
        if (variantModal === false) {
            setActiveVariant({
                variantIndex: -1,
                variantId: -1
            });
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "scroll";
            }
        } else {
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            }
        }
    }, [
        variantModal,
        detailedItem
    ]);
    var itemIndexInCart = (0,_utils_itemIndexFromCart__WEBPACK_IMPORTED_MODULE_22__/* .itemIndexFromCart */ .R)(localCartData, detailedItem);
    var onVariantSelect = function(selectedInd, item) {
        if (item.available) {
            setActiveVariant(function(state) {
                var ref;
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, state), {
                    variantIndex: selectedInd,
                    variantId: detailedItem === null || detailedItem === void 0 ? void 0 : (ref = detailedItem.variants) === null || ref === void 0 ? void 0 : ref[selectedInd].variant_id
                });
            });
            handleSetState(selectedInd);
        } else (0,_Common_Toast__WEBPACK_IMPORTED_MODULE_8__/* .toastNotifyInfo */ .lU)("Variant not available!");
    };
    var onClose = function() {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveDetailedItemById */ .VY)(null));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveProductLoaderId */ .XG)(null));
    };
    var onAddToCartBtnHandle = function() {
        if (activeVariant.variantIndex === -1) return;
        if (!getCombinedQuantityOfSelectedVariants()) {
            handleCart("add");
        }
        if (props === null || props === void 0 ? void 0 : props.isWishlistProductCard) {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
        } else {
            props.isRedirect && router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_6__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_6__.PATH.CART, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
        }
    };
    var handleCart = function(type) {
        var ref, ref1;
        if (type === "inc" && !qtyLessThanAvailQty()) {
            (0,_Common_Toast__WEBPACK_IMPORTED_MODULE_8__/* .toastNotifyInfo */ .lU)("No more units available for purchase");
            return;
        }
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveProductLoaderId */ .XG)(detailedItem.id));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .saveDetailedItemById */ .VY)(detailedItem));
        var newCart = [];
        type = type === "add" || type === "inc" ? "inc" : "dec";
        newCart = (0,_utils_mutateVariantItemWithCartData__WEBPACK_IMPORTED_MODULE_15__/* .mutateVariantItemWithCartData */ .I)(type, detailedItem, detailedItem.variants[activeVariant.variantIndex], localCartData);
        setLocalCartData(newCart);
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_24__/* .saveCart */ .FP)(newCart));
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_25__/* .pushEventsLog */ .U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeInfo === null || storeInfo === void 0 ? void 0 : storeInfo.store_id,
                domain: storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o <= _utils_constants__WEBPACK_IMPORTED_MODULE_14__/* .MAX_MOBILE_WIDTH */ .Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            }
        }));
    };
    // get sum of all quantity of selected variant
    var getCombinedQuantityOfSelectedVariants = function() {
        var ref, ref1, ref2;
        var sumVariantQuantity = 0;
        if (Object.keys(localCartData).length && (localCartData === null || localCartData === void 0 ? void 0 : (ref = localCartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.length)) {
            var ref3;
            sumVariantQuantity = (ref3 = localCartData === null || localCartData === void 0 ? void 0 : localCartData.items[itemIndexInCart]) === null || ref3 === void 0 ? void 0 : ref3.variants_selected.reduce(function(acc, curr) {
                return acc + curr.quantity;
            }, 0);
        }
        return sumVariantQuantity;
    };
    /**
   * utility function to get quantity and current item data of product
   * @return {*} obj
   */ var returnItemData = function() {
        var itemData = {
            quantity: 0,
            selectedItem: null
        };
        if (itemIndexInCart >= 0) {
            var ref, ref1, ref2;
            if (localCartData === null || localCartData === void 0 ? void 0 : (ref = localCartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.length) {
                var selectedVariant = (0,_utils_selectedVariantFromVariantList__WEBPACK_IMPORTED_MODULE_26__/* .selectedVariantFromVariantList */ .m)(localCartData, itemIndexInCart, activeVariant.variantId);
                var ref3;
                itemData = {
                    quantity: (ref3 = selectedVariant === null || selectedVariant === void 0 ? void 0 : selectedVariant.quantity) !== null && ref3 !== void 0 ? ref3 : 0,
                    selectedItem: selectedVariant ? selectedVariant : null
                };
            } else {
                var ref4, ref5, ref6;
                itemData = {
                    quantity: localCartData === null || localCartData === void 0 ? void 0 : (ref4 = localCartData.items) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[itemIndexInCart]) === null || ref5 === void 0 ? void 0 : ref5.quantity,
                    selectedItem: localCartData === null || localCartData === void 0 ? void 0 : (ref6 = localCartData.items) === null || ref6 === void 0 ? void 0 : ref6[itemIndexInCart]
                };
            }
        }
        return itemData;
    };
    /**
   * Check if quantity is less than available qty
   * @return {*} boolean
   */ var qtyLessThanAvailQty = function() {
        var selectedItem = returnItemData().selectedItem;
        if (selectedItem && !!Object.keys(selectedItem).length) {
            // only work if available qty is not 0
            if (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.available_quantity) {
                return selectedItem.quantity < selectedItem.available_quantity;
            }
        }
        return true;
    };
    var LeftCartButton = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DesignSystem_AtomicComponents_CartButton_CartButton_styles__WEBPACK_IMPORTED_MODULE_10__/* .InteractionComponent */ .$1, {
            position: "left:14px;",
            width: "30px",
            onClick: function(e) {
                e.stopPropagation();
                if (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) {
                    _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__/* .IS_CLIENT */ .kc && _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__/* ["default"].add */ .Z.add("activeVariantId", activeVariant.variantId);
                    handleSetProductData(detailedItem);
                    handleDecreamentClick("dec", detailedItem);
                    dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
                } else {
                    handleCart("dec");
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_MinusIcon__WEBPACK_IMPORTED_MODULE_11__/* .MinusIcon */ .V, {})
        });
    };
    var RightCartButton = function() {
        /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DesignSystem_AtomicComponents_CartButton_CartButton_styles__WEBPACK_IMPORTED_MODULE_10__/* .InteractionComponent */ .$1, {
            position: "right:14px;",
            width: "30px",
            onClick: function(e) {
                e.stopPropagation();
                if (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) {
                    _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__/* .IS_CLIENT */ .kc && _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__/* ["default"].add */ .Z.add("activeVariantId", activeVariant.variantId);
                    handleSetProductData(detailedItem);
                    handleIncreamentClick("inc", detailedItem);
                    dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
                } else {
                    handleCart("inc");
                }
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: qtyLessThanAvailQty() ? "o-100" : "o-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_PlusIcon__WEBPACK_IMPORTED_MODULE_12__/* .PlusIcon */ .p, {})
            })
        });
    };
    var handlePPAddToCart = function() {
        _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_17__/* .IS_CLIENT */ .kc && _utils_LocalStorageHelper__WEBPACK_IMPORTED_MODULE_16__/* ["default"].add */ .Z.add("activeVariantId", activeVariant.variantId);
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
        handleSetProductData(detailedItem);
        handleSetProductCustomizationCount(detailedItem);
        onPersonalizeProductClick();
    };
    var handleGoToCartClick = function() {
        dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_23__/* .setVariantModalVisibility */ .VZ)(false));
        router.push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_6__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_6__.PATH.CART, store_info === null || store_info === void 0 ? void 0 : store_info.domain));
    };
    return variantModal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Common_Modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        visible: variantModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0,
            maxWidth: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o <= 766 ? "100%" : 480
        },
        animation: "slideUp",
        className: "bottom-modal",
        onClose: onClose,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "variantModal",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "variantModal-section",
                    style: {
                        border: "none"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "variantModal-closeicon",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                                alt: "cancel"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            children: "Choose One"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "variant-list",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_VariantRadioGroup__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        itemLowQty: detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.low_quantity,
                        itemList: (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.variants) || [],
                        activeIdx: activeVariant.variantIndex,
                        onChange: onVariantSelect
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "add-to-cart flex justify-between",
                    children: itemIndexInCart === -1 && (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "tw-flex tw-w-full tw-cursor-pointer tw-justify-center tw-py-[0.875rem] tw-text-[15px]",
                        onClick: handlePPAddToCart,
                        style: {
                            backgroundColor: theme === null || theme === void 0 ? void 0 : (ref = theme.colors) === null || ref === void 0 ? void 0 : ref.primary_color,
                            borderRadius: theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__/* .roundnessCalculator */ .M)(theme.roundness)) : "8px",
                            color: "#FFFF"
                        },
                        children: (storeInfo === null || storeInfo === void 0 ? void 0 : (ref1 = storeInfo.theme) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.cta_config) === null || ref2 === void 0 ? void 0 : ref2.pdp_personalized_cta) || "Personalise and buy"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            !(props === null || props === void 0 ? void 0 : props.isWishlistProductCard) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-100 mr1 flex justify-center left-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_DesignSystem_AtomicComponents__WEBPACK_IMPORTED_MODULE_9__/* .CartButton */ .WE, {
                                    leftButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeftCartButton, {}),
                                    rightButton: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RightCartButton, {}),
                                    fontSize: "15",
                                    roundness: theme === null || theme === void 0 ? void 0 : theme.roundness,
                                    onChange: function(type) {
                                        (detailedItem === null || detailedItem === void 0 ? void 0 : detailedItem.product_personalization) ? handlePPAddToCart() : handleCart(type);
                                    },
                                    // sending null to handle 0 quantity issue during render
                                    quantity: returnItemData().quantity,
                                    px: "5px",
                                    py: "14px",
                                    label: "Add to Cart",
                                    borderColor: "#00000000",
                                    style: {
                                        justifyContent: "center",
                                        width: _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_3__/* .deviceWidth */ .o > 540 ? "75%" : "100%"
                                    },
                                    wrapperClasses: "tw-w-full"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-100 ml1 right-0",
                                children: !getCombinedQuantityOfSelectedVariants() ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "pointer",
                                    style: {
                                        backgroundColor: "".concat(theme ? theme === null || theme === void 0 ? void 0 : (ref3 = theme.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : "#EA5151"),
                                        borderRadius: "".concat(theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__/* .roundnessCalculator */ .M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"),
                                        opacity: "1"
                                    },
                                    onClick: onAddToCartBtnHandle,
                                    children: (0,_utils_getCustomCtaText__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)("buy_now_cta")
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "pointer",
                                    style: {
                                        backgroundColor: "#369d00",
                                        borderRadius: "".concat(theme ? "".concat((0,_components_DesignSystem_AtomicComponents_util__WEBPACK_IMPORTED_MODULE_27__/* .roundnessCalculator */ .M)(theme === null || theme === void 0 ? void 0 : theme.roundness)) : "8px"),
                                        opacity: "1"
                                    },
                                    onClick: function() {
                                        handleGoToCartClick();
                                    },
                                    children: "Go to Cart"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VariantModal);


/***/ }),

/***/ 284557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_VariantSelectedListModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(731024);
// EXTERNAL MODULE: ./src/redux/actions/logs.js
var logs = __webpack_require__(467936);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var cart = __webpack_require__(666162);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(672651);
;// CONCATENATED MODULE: ./src/components/Common/IncDecButton/index.js
/**
 * Increament Decreament Button for Catalog Items
 */ 

var IncDecButton = function(param) {
    var quantity = param.quantity, onChangeEventhandle = param.onChangeEventhandle, _showAddAction = param.showAddAction, showAddAction = _showAddAction === void 0 ? -1 : _showAddAction, catalogCta = param.catalogCta, showLoader = param.showLoader, _disableAddition = param.disableAddition, disableAddition = _disableAddition === void 0 ? false : _disableAddition;
    var styleClass = catalogCta ? "addtocart" : "pdp-addtocart";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(styleClass, "-btn"),
        style: !catalogCta ? {
            backgroundColor: "".concat(quantity <= 0 ? "#EA5151" : "#ffffff")
        } : {
            backgroundColor: "#ffffff"
        },
        children: [
            showAddAction < 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat(styleClass, "-btn__changeIcon"),
                onClick: function() {
                    return onChangeEventhandle("add");
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "ADD",
                            !catalogCta && "+"
                        ]
                    }),
                    catalogCta && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        loading: "lazy",
                        src: "https://cdn.dotpe.in/longtail/themes/8073865/P6ghQCtu.webp",
                        alt: "Add Item button"
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                style: {
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__changeIcon"),
                        onClick: function() {
                            return onChangeEventhandle("dec");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            loading: "lazy",
                            src: "https://cdn.dotpe.in/longtail/themes/8073865/GPgsbV9o.webp",
                            alt: "Decreament button"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__text"),
                        children: quantity
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(styleClass, "-btn__changeIcon"),
                        onClick: function() {
                            return onChangeEventhandle("inc");
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "din ".concat(disableAddition ? "o-20" : "o-100"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                loading: "lazy",
                                src: "https://cdn.dotpe.in/longtail/themes/8073865/P6ghQCtu.webp",
                                alt: "Increment button"
                            })
                        })
                    })
                ]
            }),
            showLoader && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "loading-wrapper"
            })
        ]
    });
};
/* harmony default export */ var Common_IncDecButton = (IncDecButton);

// EXTERNAL MODULE: ./src/utils/deviceWidth.js
var deviceWidth = __webpack_require__(186812);
// EXTERNAL MODULE: ./src/utils/itemQuantityValueComparison.js
var itemQuantityValueComparison = __webpack_require__(973175);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/mutateVariantItemWithCartData.js
var mutateVariantItemWithCartData = __webpack_require__(759186);
// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(644779);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/hooks/useCartHandler.js
var useCartHandler = __webpack_require__(491240);
;// CONCATENATED MODULE: ./src/components/VariantSelectedListModal/index.js

















var VariantSelectedListModal = function(props) {
    var ref, ref1, ref2;
    var ref3 = (0,useCartHandler/* useCartHandlers */.u)(), handleIncreamentClick = ref3.handleIncreamentClick, handleDecreamentClick = ref3.handleDecreamentClick, handleSetProductData = ref3.handleSetProductData;
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,react.useState)({
        itemCartIndex: null
    }), state = ref4[0], setState = ref4[1];
    var ref5 = (0,es/* useSelector */.v9)(function(state) {
        return state.commonReducer;
    }), selectedVariantsModal = ref5.variant.selectedVariantsModal, productLoaderId = ref5.productLoaderId;
    var ref6 = (0,es/* useSelector */.v9)(function(state) {
        return {
            userData: state.userReducer,
            storeData: state.storeReducer.store,
            cartData: state.cartReducer,
            pdpData: state.catalogReducer.pdpData
        };
    }), userData = ref6.userData, storeData = ref6.storeData, cartData = ref6.cartData, pdpData = ref6.pdpData;
    (0,react.useEffect)(function() {
        if (selectedVariantsModal) {
            var ref;
            var productIndex = cartData.items.findIndex(function(el) {
                return el.item_id === productLoaderId;
            });
            setState(function(state) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    itemCartIndex: productIndex
                });
            });
            if (productLoaderId) {
                dispatch((0,catalog/* fetchCatalogItemById */.eP)({
                    store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                    item_id: productLoaderId,
                    src: "variant_selected_modal"
                }, false, function(data) {
                    handleSetProductData(data);
                    dispatch((0,catalog/* savePDPData */.zP)(data));
                }));
            }
            if (cartData && !(cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : ref[productIndex])) {
                onClose();
            }
        }
    }, [
        selectedVariantsModal,
        cartData,
        productLoaderId
    ]);
    (0,react.useEffect)(function() {
        if (selectedVariantsModal) {
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "hidden";
            }
        } else {
            if (document.getElementsByTagName("body")[0] && document.getElementsByTagName("body")[0].style) {
                document.getElementsByTagName("body")[0].style.overflowY = "scroll";
            }
        }
    }, [
        selectedVariantsModal
    ]);
    var onClose = function() {
        dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(false));
    };
    var handleAddRemoveItem = function(type, variantType) {
        var ref, ref1, ref2;
        dispatch((0,logs/* pushEventsLog */.U)({
            event_name: "Cx_ATC",
            data: {
                store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                domain: storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain,
                page: window.location.href,
                device: deviceWidth/* deviceWidth */.o <= constants/* MAX_MOBILE_WIDTH */.Cf ? "Mobile" : "Desktop",
                cx_number: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            }
        }));
        var newCart = (0,mutateVariantItemWithCartData/* mutateVariantItemWithCartData */.I)(type, cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : ref2[state.itemCartIndex], variantType, cartData);
        dispatch((0,cart/* saveCart */.FP)(newCart));
    };
    var handleOnChange = function(type, variant) {
        if (pdpData === null || pdpData === void 0 ? void 0 : pdpData.product_personalization) {
            handleSetProductData(pdpData);
            checkRenderEnv/* IS_CLIENT */.kc && LocalStorageHelper/* default.add */.Z.add("activeVariantId", variant === null || variant === void 0 ? void 0 : variant.variant_id);
            if (type === "inc") {
                handleIncreamentClick(type, pdpData);
            } else if (type === "dec") {
                handleDecreamentClick(type, pdpData);
            }
            dispatch((0,common/* setSelectedVariantModalVisibility */.rV)(false));
        } else {
            handleAddRemoveItem(type, variant);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: selectedVariantsModal,
        customStyles: {
            paddingLeft: 0,
            paddingRight: 0
        },
        height: "auto",
        animation: "slideUp",
        className: "bottom-modalVvariantSelectedListModal",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "closeicon pointer",
                onClick: onClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    loading: "lazy",
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/9sE359Sh.webp",
                    alt: "cancel"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "title",
                children: "Choose Item to remove"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "item-list",
                children: cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[state.itemCartIndex]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.variants_selected) === null || ref2 === void 0 ? void 0 : ref2.map(function(variant, ind) {
                    var ref, ref1, ref2, ref3;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "item",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex items-start justify-start",
                                children: [
                                    variant.images && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: variant === null || variant === void 0 ? void 0 : (ref = variant.images) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.image_url,
                                        className: "img h3",
                                        alt: "variant image ".concat(ind + 1)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("article", {
                                        className: "left ml2",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "item-name",
                                                children: cartData === null || cartData === void 0 ? void 0 : (ref2 = cartData.items) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[state.itemCartIndex]) === null || ref3 === void 0 ? void 0 : ref3.name
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "variant-name",
                                                children: variant.variant_name
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
                                className: "right",
                                style: {
                                    justifyContent: "flex-end"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_IncDecButton, {
                                    disableAddition: (0,itemQuantityValueComparison/* itemQuantityValueComparison */.i)(variant),
                                    catalogCta: true,
                                    showAddAction: 1,
                                    quantity: variant.quantity,
                                    onChangeEventhandle: function(change) {
                                        return handleOnChange(change, variant);
                                    }
                                })
                            })
                        ]
                    }, "items-variant-".concat(ind));
                })
            })
        ]
    });
};
/* harmony default export */ var components_VariantSelectedListModal = (VariantSelectedListModal);


/***/ }),

/***/ 602641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ compareListData; },
/* harmony export */   "k": function() { return /* binding */ flattenCollectionCategoryItems; }
/* harmony export */ });
/**
   * function to convert nested collection category data to flattened format
   * eg.
   * ## original data
   * [
   *    collection: {
   *      category1: [item1, item2, item3],
   *      category2: [item1, item2, item3],
   *    },
   *    collection: {
   *      category1: [item1, item2, item3],
   *      category2: [item1, item2, item3],
   *    },
   * ]
   *
   * ## parsed data
   * note:- item can be a skeleton loader or a proper `FlattenRowDataType` object if loading is complete
   * [
   *  collection_heading, -> (as a component type item in the array)
   *  category_heading, -> (as a component type item in the array)
   *  item1,
   *  item2,
   *  collection_heading2, -> (as a component type item in the array)
   *  category_heading2, -> (as a component type item in the array)
   *  item1,
   *  item2,
   * ]
   */ function flattenCollectionCategoryItems(param) {
    var collections = param.collections, collectionCatalogItems = param.collectionCatalogItems, _skeletonCardsCount = param.skeletonCardsCount, skeletonCardsCount = _skeletonCardsCount === void 0 ? 3 : _skeletonCardsCount, collectionObject = param.collectionObject, categoryObject = param.categoryObject, itemObject = param.itemObject;
    var flattenData = [];
    collections.forEach(function(collection) {
        var ref;
        flattenData.push(collectionObject(collection));
        (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.map(function(category) {
            var ref, ref1;
            flattenData.push(categoryObject(collection, category));
            if ((collectionCatalogItems === null || collectionCatalogItems === void 0 ? void 0 : (ref = collectionCatalogItems[collection.id]) === null || ref === void 0 ? void 0 : (ref1 = ref[category.id]) === null || ref1 === void 0 ? void 0 : ref1.length) > 0) {
                var ref2, ref3;
                collectionCatalogItems === null || collectionCatalogItems === void 0 ? void 0 : (ref2 = collectionCatalogItems[collection.id]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[category.id]) === null || ref3 === void 0 ? void 0 : ref3.forEach(function(productItem) {
                    return flattenData.push(itemObject(collection, category, productItem));
                });
            } else {
                Array(skeletonCardsCount).fill(0).map(function(_, index) {
                    flattenData.push({
                        id: "".concat(collection.id, "-").concat(category.id, "-").concat(index),
                        type: "product-card-skeleton"
                    });
                });
            }
        });
    });
    return flattenData;
}
var compareListData = function(prevProps, nextProps) {
    var ref, ref1, ref2;
    if (((ref = prevProps.listData) === null || ref === void 0 ? void 0 : ref.length) !== ((ref1 = nextProps.listData) === null || ref1 === void 0 ? void 0 : ref1.length)) return false;
    for(var i = 0; i < ((ref2 = prevProps.listData) === null || ref2 === void 0 ? void 0 : ref2.length); i++){
        var ref3, ref4;
        if (((ref3 = prevProps.listData[i]) === null || ref3 === void 0 ? void 0 : ref3.id) !== ((ref4 = nextProps.listData[i]) === null || ref4 === void 0 ? void 0 : ref4.id)) {
            return false;
        }
    }
    return true;
};


/***/ }),

/***/ 185810:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ CustomizedSnackbar; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(414924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(269396);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10253);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _mui_material_Snackbar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(226379);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(40416);
/* harmony import */ var _assets_svgExports_TickFill__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72084);
/* harmony import */ var src_hooks_useGetDeviceType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(662946);






// eslint-disable-next-line import/named

// eslint-disable-next-line import/named



function CustomizedSnackbar(param) {
    var config = param.config, _autoHideDuration = param.autoHideDuration, autoHideDuration = _autoHideDuration === void 0 ? 4500 : _autoHideDuration, handleSnackbarClose = param.handleSnackbarClose;
    var isMobile = (0,src_hooks_useGetDeviceType__WEBPACK_IMPORTED_MODULE_3__/* .useGetDeviceType */ .n)().isMobile;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState({
        open: false,
        message: "",
        vertical: "top",
        horizontal: "right",
        type: "success"
    }), 2), state = ref[0], setState = ref[1];
    var vertical = state.vertical, horizontal = state.horizontal;
    var open = config.open, message = config.message;
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        setState((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state, config));
    }, [
        config
    ]);
    var icon = function() {
        switch(state.type){
            case "success":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_TickFill__WEBPACK_IMPORTED_MODULE_2__/* .TickFill */ .v, {
                    width: 17,
                    height: 17,
                    color: "#32B272"
                });
            default:
                return null;
        }
    }();
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Snackbar__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        sx: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, horizontal === "center" && isMobile ? {
            left: "10% !important",
            right: "10% !important"
        } : {}), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, "& .".concat(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"].root */ .Z.root), {
            minWidth: "auto",
            padding: "0px 0px"
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_obj, "& .".concat(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"].message */ .Z.message), {
            width: "100%",
            padding: "15px 20px",
            borderRadius: "6px",
            backgroundColor: "#111C36",
            boxShadow: "0px 4px 4px 0px #00000040"
        }), _obj)),
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        open: open,
        onClose: handleSnackbarClose,
        message: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "tw-flex tw-items-center tw-justify-center tw-gap-[8px]",
            children: [
                icon,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: " tw-m-0 tw-font-inter ",
                    children: message
                })
            ]
        })
    }, vertical + horizontal);
}


/***/ }),

/***/ 692687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _404Page; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(353978);
// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(698616);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(268037);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
;// CONCATENATED MODULE: ./src/assets/svgExports/SearchIcon404.js


var SearchIcon404 = function(param) {
    var height = param.height, width = param.width;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: width,
        height: height,
        fill: "none",
        viewBox: "0 0 201 200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "m132.534 99.053-33.146 33.144s11.787-3.681 28.728 2.209c2.85.991 7.618-3.778 6.628-6.628-5.891-16.94-2.21-28.725-2.21-28.725",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#F7F7F7",
                fillRule: "evenodd",
                d: "M43.825 43.488c20.125-20.122 52.797-20.122 72.922 0 20.122 20.124 20.122 52.796 0 72.921-20.125 20.122-52.797 20.122-72.922 0-20.122-20.125-20.122-52.797 0-72.922",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E9E9E9",
                fillRule: "evenodd",
                d: "M110.081 37.856a52 52 0 0 1 6.666 5.631c20.122 20.125 20.122 52.797 0 72.922-20.125 20.122-52.797 20.122-72.922 0a53 53 0 0 1-3.347-3.681c19.506 6.338 41.8 1.763 57.288-13.725 16.518-16.519 20.625-40.781 12.315-61.147",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BABABA",
                fillRule: "evenodd",
                d: "M39.406 39.069c22.563-22.563 59.197-22.563 81.76 0 22.562 22.562 22.562 59.197 0 81.759-22.563 22.563-59.197 22.563-81.76 0-22.562-22.562-22.562-59.197 0-81.76m6.628 6.628c18.904-18.903 49.6-18.903 68.504 0 18.903 18.903 18.903 49.6 0 68.503-18.904 18.903-49.6 18.903-68.504 0-18.903-18.903-18.903-49.6 0-68.503",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#BABABA",
                fillRule: "evenodd",
                d: "M28.49 105.656c-10.724-21.622-7.087-48.584 10.916-66.587 16.907-16.906 41.713-21.144 62.585-12.713a74.5 74.5 0 0 1 .09 10.325c-18.16-9.143-40.89-6.137-56.047 9.016-16.065 16.066-18.478 40.65-7.23 59.275-3.295.45-6.657.684-10.07.684z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "M125.584 145.134c-5.49-5.49-5.49-14.393 0-19.887 5.491-5.491 14.397-5.491 19.888 0l45.3 45.3c1.219 1.219-2.247 6.666-7.734 12.153-5.488 5.488-10.935 8.953-12.154 7.734z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#E9E9E9",
                fillRule: "evenodd",
                d: "M125.584 145.134c-5.49-5.49-5.49-14.393 0-19.887 5.491-5.491 14.397-5.491 19.888 0l41 41c1.219 1.219-2.247 6.666-7.734 12.153-5.488 5.488-10.935 8.953-12.154 7.734z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "M73.666 70.11c-.072-2.979 1.047-5.154 2.772-6.429 2.712-2 6.765-1.915 8.965.563.944 1.065 1.49 2.572 1.506 4.478.038 4.572-2.106 7.244-4.206 10.01-2.825 3.727-5.647 7.559-5.997 13.956a3.127 3.127 0 0 0 6.244.34c.263-4.86 2.587-7.69 4.734-10.522 2.875-3.79 5.529-7.572 5.475-13.834-.03-3.681-1.259-6.522-3.084-8.578-4.263-4.8-12.09-5.319-17.347-1.444-3.15 2.325-5.44 6.175-5.312 11.606a3.127 3.127 0 0 0 6.25-.147",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                d: "M79.538 107.584a3.844 3.844 0 1 0 0-7.687 3.844 3.844 0 0 0 0 7.687"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                fill: "#4E4E4E",
                fillRule: "evenodd",
                d: "m135.775 26.553 9.375-15.625a3.124 3.124 0 1 0-5.359-3.216l-9.375 15.625a3.125 3.125 0 1 0 5.359 3.216M150.559 36.85l34.375-25a3.13 3.13 0 0 0 .691-4.366 3.13 3.13 0 0 0-4.366-.69l-34.375 25a3.127 3.127 0 0 0 3.675 5.056M155.728 56.103l25-6.25a3.126 3.126 0 1 0-1.515-6.062l-25 6.25a3.124 3.124 0 0 0 1.515 6.063",
                clipRule: "evenodd"
            })
        ]
    });
};
/* harmony default export */ var svgExports_SearchIcon404 = (SearchIcon404);

// EXTERNAL MODULE: ./src/utils/getWindowDimension.js
var getWindowDimension = __webpack_require__(37110);
// EXTERNAL MODULE: ./src/utils/handleRedirectToHomePage.js
var handleRedirectToHomePage = __webpack_require__(254051);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
;// CONCATENATED MODULE: ./src/containers/404Page/ErrorMsg.tsx







var ErrorMsg = function() {
    var store = (0,es/* useSelector */.v9)(function(state) {
        return {
            store: state.storeReducer.store
        };
    }).store;
    var isDesktop = (0,getWindowDimension/* default */.Z)().isDesktop;
    var ref = function() {
        var size = isDesktop ? 200 : 100;
        return {
            height: size,
            width: size
        };
    }(), height = ref.height, width = ref.width;
    var goToHomePage = function() {
        (0,handleRedirectToHomePage/* redirectToHomePage */.A)(routes.PATH.PRODUCT, store === null || store === void 0 ? void 0 : store.domain);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "tw-static tw-flex tw-flex-col tw-bg-white ".concat(isDesktop ? "tw-my-[78px] tw-gap-[60px]" : "tw-my-[138px] tw-gap-[48px]"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "tw-flex tw-flex-col tw-items-center ".concat(isDesktop ? "tw-gap-[40px]" : "tw-gap-[32px]"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(svgExports_SearchIcon404, {
                        height: height,
                        width: width
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "msg tw-flex tw-flex-col tw-gap-16 tw-text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tw-font-inter tw-text-[22px]/[32px] tw-font-semibold tw-text-[#000000] md:tw-text-[32px]/[44px] md:tw-font-semibold",
                                children: "Uh oh, this page does not exist."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "tw-font-inter tw-text-[14px] tw-font-normal tw-leading-[22px] tw-text-[#00000099] md:tw-text-[18px]/7",
                                children: [
                                    "You may have mistyped the address or the ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " page may have been removed."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "tw-flex tw-justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    onClick: goToHomePage,
                    className: "tw-mx-auto tw-w-[90%] tw-cursor-pointer tw-rounded-lg tw-border-none tw-bg-[#2B74D8] tw-px-24 tw-py-10 tw-font-inter tw-text-[14px] tw-font-semibold tw-leading-8 tw-text-white md:tw-w-auto md:tw-text-[16px]",
                    children: "Go to home page"
                })
            })
        ]
    });
};
/* harmony default export */ var _404Page_ErrorMsg = (ErrorMsg);

// EXTERNAL MODULE: ./src/utils/ssrCommonApiCall.ts + 1 modules
var ssrCommonApiCall = __webpack_require__(122987);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
;// CONCATENATED MODULE: ./src/containers/404Page/index.tsx









var Error404 = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeInfo = (0,redux/* useSSRSelector */.kF)(function(state) {
        return state.storeReducer.store;
    });
    (0,react.useEffect)(function() {
        (0,ssrCommonApiCall/* ssrDataCall */.z)([
            "collections",
            "categories",
            "seo"
        ], storeInfo).then(function(data) {
            dispatch((0,catalog/* saveCatalogCategories */.FF)((data === null || data === void 0 ? void 0 : data.catalogCategories) || []));
            dispatch((0,catalog/* saveCollections */.VN)((data === null || data === void 0 ? void 0 : data.collections) || []));
            dispatch((0,catalog/* saveCatalogTags */.Vj)((data === null || data === void 0 ? void 0 : data.catalogTags) || []));
        });
    }, [
        storeInfo
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "ErrorPage_wrapper",
        children: [
            (ref = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(_404Page_ErrorMsg, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "EroorPage_body_wrapper",
                children: (ref3 = (0,specificThemeRender/* specificThemeRender */.t)(storeInfo)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Footer) === null || ref5 === void 0 ? void 0 : ref5.map(function(layout) {
                    return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
                })
            })
        ]
    });
};
/* harmony default export */ var _404Page = (Error404);


/***/ }),

/***/ 676671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_Collections; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
;// CONCATENATED MODULE: ./src/utils/isTimerExpired.js


/**
 *
 * @returns boolean indicating whether the clicked item's timestamp is within the state refresh period (expiry interval)
 */ function isTimerExpired() {
    var expired = true;
    if (!checkRenderEnv/* IS_SERVER */.W6) {
        var sessionData = JSON.parse(sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(constants/* ITEM_CLICKED_DATA */.rB));
        if (sessionData) {
            var expiresAt = new Date(sessionData.expiresAt);
            var currentTime = new Date();
            expired = currentTime > expiresAt;
        }
    }
    if (expired) {
        sessionStorage.removeItem(constants/* COLLECTION_CATALOG_ITEMS */.C$);
        sessionStorage.removeItem(constants/* ITEM_CLICKED_DATA */.rB);
    }
    // If session data doesn't exist or if running in server, consider timer as expired
    return expired;
}

// EXTERNAL MODULE: ./src/utils/specificThemeRender.ts
var specificThemeRender = __webpack_require__(698616);
// EXTERNAL MODULE: ./src/utils/themeImports.js + 1 modules
var themeImports = __webpack_require__(353978);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/components/VariantModal/index.js
var VariantModal = __webpack_require__(740261);
// EXTERNAL MODULE: ./src/components/VariantChooseRepeatModal/index.js
var VariantChooseRepeatModal = __webpack_require__(932948);
// EXTERNAL MODULE: ./src/components/VariantSelectedListModal/index.js + 1 modules
var VariantSelectedListModal = __webpack_require__(284557);
// EXTERNAL MODULE: ./src/components/DesignSystem/QuickViewModal/index.js + 4 modules
var QuickViewModal = __webpack_require__(75684);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/AdvanceCatalogMiddleBody1.js + 27 modules
var AdvanceCatalogMiddleBody1 = __webpack_require__(369142);
// EXTERNAL MODULE: ./src/utils/useIsComponentMounted.js
var useIsComponentMounted = __webpack_require__(471778);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/utils/LocalStorageHelper.js
var LocalStorageHelper = __webpack_require__(644779);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./src/components/FlatList/index.js
var FlatList = __webpack_require__(155772);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/PromoSlider/index.tsx + 1 modules
var PromoSlider = __webpack_require__(698521);
// EXTERNAL MODULE: ./src/constants/promos.js
var promos = __webpack_require__(810445);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/index.ts
var ProductListWrapper = __webpack_require__(368464);
// EXTERNAL MODULE: ./src/containers/Collections/useGetTypeIdFromCanonicalDataStore.js
var useGetTypeIdFromCanonicalDataStore = __webpack_require__(130553);
;// CONCATENATED MODULE: ./src/containers/Collections/CollectionCategory.tsx













var CollectionCategory = function() {
    var ref, ref1;
    var ref2 = (0,react.useState)(null), activeCategoryId = ref2[0], setActiveCategoryId = ref2[1];
    var dispatch = (0,es/* useDispatch */.I0)();
    var typeId = (0,useGetTypeIdFromCanonicalDataStore/* useGetTypeIdFromCanonicalDataStore */.C)().typeId;
    (0,react.useEffect)(function() {
        setActiveCategoryId(typeId);
    }, [
        typeId
    ]);
    var collections = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.catalogReducer.collections;
    });
    var storeCollection = collections === null || collections === void 0 ? void 0 : collections.filter(function(collection) {
        return collection.id === typeId;
    });
    var collection = (storeCollection === null || storeCollection === void 0 ? void 0 : storeCollection.length) > 0 ? storeCollection[0] : null;
    var collectionCatalogItems = (0,es/* useSelector */.v9)(function(state) {
        return {
            collectionCatalogItems: state.catalogReducer.collectionCatalogItems
        };
    }).collectionCatalogItems;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    /**
   * @return collectionCatalogItems from localstorage if it exists and within the cache clear time interval, else it will return from redux store.
   */ var fetchCollectionCatalogItems = function() {
        var storedCollectionCatalogItems = LocalStorageHelper/* default.get */.Z.get(constants/* COLLECTION_CATALOG_ITEMS */.C$);
        if (storedCollectionCatalogItems && !isTimerExpired()) {
            return JSON.parse(storedCollectionCatalogItems);
        }
        return collectionCatalogItems;
    };
    var returnNestedCollectionData = function(collectionId, categoryId) {
        var collectionCatalogItemList = fetchCollectionCatalogItems();
        var collectionIdValue = collectionCatalogItemList[collectionId];
        if (collectionIdValue) {
            return collectionIdValue[categoryId];
        }
        return null;
    };
    var loadMoreData = function(category, collection) {
        if (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) {
            dispatch((0,catalog/* fetchCollectionCatalogItemById */.lA)({
                storeId: storeData.store_id,
                collectionId: collection === null || collection === void 0 ? void 0 : collection.id,
                categoryId: category === null || category === void 0 ? void 0 : category.id
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
        className: "collections-main",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "collections-body center",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        "data-id": collection === null || collection === void 0 ? void 0 : collection.id,
                        className: "collection-heading tc",
                        children: collection === null || collection === void 0 ? void 0 : collection.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoSlider/* default */.Z, {
                        type: promos/* PROMO_APPLICABILITY_TYPES.COLLECTION */.d.COLLECTION,
                        typeId: collection === null || collection === void 0 ? void 0 : collection.id
                    }),
                    (ref1 = collection === null || collection === void 0 ? void 0 : (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.filter(function(category) {
                        return "".concat(category.id) === "".concat(activeCategoryId);
                    })) === null || ref1 === void 0 ? void 0 : ref1.map(function(category) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            "data-id": category.id,
                            className: "category-items-section",
                            id: category.id,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                    className: "category-item-header",
                                    children: category.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "md:pt-[20px] pb-[24px] tw-pt-[10px]",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatList/* default */.Z, {
                                        isLoaderVisible: false,
                                        isNext: returnNestedCollectionData(collection.id, category.id) ? false : true,
                                        onScrollEnd: function() {
                                            return loadMoreData(category, collection);
                                        },
                                        renderInsideFragment: true,
                                        // add LoaderComponent for loading sections
                                        renderList: function() {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                                                productList: returnNestedCollectionData(collection.id, category.id),
                                                oldCardConfigs: {
                                                    showButton: true,
                                                    noTagsReadState: "fromLength"
                                                }
                                            });
                                        }
                                    })
                                })
                            ]
                        }, category.id);
                    })
                ]
            }, collection === null || collection === void 0 ? void 0 : collection.id)
        })
    });
};
/* harmony default export */ var Collections_CollectionCategory = (CollectionCategory);

// EXTERNAL MODULE: ./src/components/ProductCustomizationPopUp/index.js + 7 modules
var ProductCustomizationPopUp = __webpack_require__(924648);
// EXTERNAL MODULE: ./src/components/FullPageLoader/FullPageLoader.js
var FullPageLoader = __webpack_require__(315241);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/PromosDrawerAndButton/index.tsx + 3 modules
var PromosDrawerAndButton = __webpack_require__(590042);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(693967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(313508);
// EXTERNAL MODULE: ./src/containers/Collections/FlatListV2.tsx
var FlatListV2 = __webpack_require__(698331);
;// CONCATENATED MODULE: ./src/containers/Collections/index.tsx



























var Collections = function(props) {
    var isBodyAdvanceCatalog = function isBodyAdvanceCatalog() {
        var ref, ref1;
        if (!isTypeCollection) return false;
        if (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : ref1.PLP) {
            var ref2, ref3, ref4, ref5;
            return (storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.components) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.PLP) === null || ref4 === void 0 ? void 0 : (ref5 = ref4[0]) === null || ref5 === void 0 ? void 0 : ref5.name) === "SortingAndFilterWidget1";
        }
    };
    var renderDefaultCollectionMiddleBody = function renderDefaultCollectionMiddleBody() {
        /** If the route contains a cid, that means we just want to display products corresponding to that category ID, hence return CollectionCategory component */ if (isTypeCategory) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collections_CollectionCategory, (0,_object_spread/* default */.Z)({}, props));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("article", {
            className: "collections-main",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "collections-body center",
                children: storeCollection === null || storeCollection === void 0 ? void 0 : storeCollection.map(function(collection) {
                    var ref;
                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                "data-id": collection.id,
                                className: "collection-heading tc",
                                children: collection.name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoSlider/* default */.Z, {
                                type: promos/* PROMO_APPLICABILITY_TYPES.COLLECTION */.d.COLLECTION,
                                typeId: collection.id
                            }),
                            collection === null || collection === void 0 ? void 0 : (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.map(function(category) {
                                var productList = returnNestedCollectionData(collection.id, category.id);
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    "data-id": category.id,
                                    className: classnames_default()("category-items-section", checkClientDeviceType/* IS_MOBILE */.q$ ? "tw-mb-[24px]" : "tw-mb-[52px]"),
                                    id: category.id,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                            className: classnames_default()("category-item-header", checkClientDeviceType/* IS_MOBILE */.q$ ? "tw-mb-[6px]" : "tw-mb-[10px]"),
                                            children: category.name
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "md:pt-[20px] pb-[24px] tw-pt-[10px]",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatListV2/* default */.Z, {
                                                loadMoreData: function() {
                                                    return !productList && loadMoreData(category, collection);
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                                                    productList: productList,
                                                    oldCardConfigs: {
                                                        showButton: true,
                                                        noTags: false
                                                    }
                                                })
                                            })
                                        })
                                    ]
                                }, category.id);
                            })
                        ]
                    }, collection.id);
                })
            })
        });
    };
    var ref, ref1, ref2, ref3, ref4, ref5;
    var dispatch = (0,es/* useDispatch */.I0)();
    var isComponentMounted = (0,useIsComponentMounted/* default */.Z)();
    var collections = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return state.catalogReducer.collections;
    });
    var ref6 = (0,useGetTypeIdFromCanonicalDataStore/* useGetTypeIdFromCanonicalDataStore */.C)(), typeId = ref6.typeId, isTypeCollection = ref6.isTypeCollection, isTypeCategory = ref6.isTypeCategory;
    var storeCollection = collections === null || collections === void 0 ? void 0 : collections.filter(function(collection) {
        return collection.id === typeId;
    });
    var collectionCatalogItems = (0,es/* useSelector */.v9)(function(state) {
        return {
            collectionCatalogItems: state.catalogReducer.collectionCatalogItems
        };
    }).collectionCatalogItems;
    var ref7 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref;
        return {
            storeData: state.storeReducer.store,
            personalizedProduct: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.personalizedProduct
        };
    }), storeData = ref7.storeData, personalizedProduct = ref7.personalizedProduct;
    /**
   * @return collectionCatalogItems from localstorage if it exists and within the cache clear time interval, else it will return from redux store.
   */ var fetchCollectionCatalogItems = function() {
        var storedCollectionCatalogItems = LocalStorageHelper/* default.get */.Z.get(constants/* COLLECTION_CATALOG_ITEMS */.C$);
        if (storedCollectionCatalogItems && !isTimerExpired()) {
            return JSON.parse(storedCollectionCatalogItems);
        }
        return collectionCatalogItems;
    };
    var returnNestedCollectionData = function(collectionId, categoryId) {
        var collectionCatalogItemList = fetchCollectionCatalogItems();
        var collectionIdValue = collectionCatalogItemList[collectionId];
        var categoryIdValue = undefined;
        if (collectionIdValue) {
            categoryIdValue = collectionIdValue[categoryId];
        }
        return categoryIdValue;
    };
    var loadMoreData = function(category, collection) {
        if (storeData === null || storeData === void 0 ? void 0 : storeData.store_id) {
            dispatch((0,catalog/* fetchCollectionCatalogItemById */.lA)({
                storeId: storeData.store_id,
                collectionId: collection.id,
                categoryId: category.id
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "collections-page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullPageLoader/* FullPageLoader */.B, {}),
            (ref = (0,specificThemeRender/* specificThemeRender */.t)(storeData)) === null || ref === void 0 ? void 0 : (ref1 = ref.components) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Header) === null || ref2 === void 0 ? void 0 : ref2.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
            }),
            isBodyAdvanceCatalog() ? isComponentMounted && /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvanceCatalogMiddleBody1["default"], {}) : isComponentMounted && renderDefaultCollectionMiddleBody(),
            (ref3 = (0,specificThemeRender/* specificThemeRender */.t)(storeData)) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.Footer) === null || ref5 === void 0 ? void 0 : ref5.map(function(layout) {
                return (0,themeImports/* getThemeComponent */.s)(layout.sub_type, layout.name, layout);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantModal["default"], {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantChooseRepeatModal["default"], {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(VariantSelectedListModal["default"], {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuickViewModal["default"], {}),
            (personalizedProduct === null || personalizedProduct === void 0 ? void 0 : personalizedProduct.personalizationPopUp) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCustomizationPopUp/* ProductCustomizationPopUp */.X, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PromosDrawerAndButton["default"], {})
        ]
    });
};
/* harmony default export */ var containers_Collections = (Collections);


/***/ }),

/***/ 780058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ useItemClick; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(147568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(197582);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
;// CONCATENATED MODULE: ./src/utils/storeProductClickedDetails.js

function storeProductClickedDetails() {
    var expiresAt = new Date(new Date().getTime() + 30000);
    var sessionObject = {
        expiresAt: expiresAt,
        itemClickedData: {
            CLICKED_ITEM_X_OFFSET: scrollX,
            CLICKED_ITEM_Y_OFFSET: scrollY
        }
    };
    sessionStorage.setItem(constants/* CLICKED_ITEM_OBJ */.uI, JSON.stringify(sessionObject));
}

// EXTERNAL MODULE: ./src/utils/canShowPDPSystem.js
var canShowPDPSystem = __webpack_require__(813051);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./src/utils/productUtils.ts
var productUtils = __webpack_require__(236913);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./src/utils/isStoreB2B.js
var isStoreB2B = __webpack_require__(43935);
;// CONCATENATED MODULE: ./src/hooks/useItemClick.js










function useItemClick() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var getProductRoute = function(product) {
        var ref;
        var productUrl = product === null || product === void 0 ? void 0 : product.link;
        var productRoute = (0,routes.getRoute)((0,productUtils/* getProductPathFromUrl */.ts)(productUrl, false), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain);
        return productRoute;
    };
    /**
   * to go to product description page, special characters are not allowed.
   * using regex to remove all special characters with '-'
   * @param {*} item
   * @param {*} e
   */ var onItemClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(item) {
            var e, openInNewTab, ref, getRoute, productRoute, paramStr, productRouteWithParam;
            var _arguments = arguments;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        e = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null, openInNewTab = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : false;
                        storeProductClickedDetails();
                        e && (e === null || e === void 0 ? void 0 : e.stopPropagation());
                        sessionStorage.setItem(constants/* CLICKED_ITEM_X_OFFSET */.AB, scrollX);
                        sessionStorage.setItem(constants/* CLICKED_ITEM_Y_OFFSET */.WR, scrollY);
                        return [
                            4,
                            Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 540190)).then(function(module) {
                                return module.getRoute;
                            })
                        ];
                    case 1:
                        getRoute = _state.sent();
                        return [
                            4,
                            getProductRoute(item, getRoute)
                        ];
                    case 2:
                        productRoute = _state.sent();
                        /** if color is there push with color in query params */ if (item === null || item === void 0 ? void 0 : item.color) {
                            paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
                            productRouteWithParam = productRoute + paramStr;
                            window.location.href = productRouteWithParam;
                        } else if (!(0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class) && !(0,isStoreB2B/* isB2BStore */.h)()) {
                            dispatch((0,catalog/* savePDPData */.zP)({
                                visible: true,
                                product: item
                            }));
                        } else {
                            openInNewTab ? window.open(productRoute, "_blank") : window.location.href = productRoute;
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onItemClick(item) {
            return _ref.apply(this, arguments);
        };
    }();
    var getLink = function(item, getRoute) {
        var ref;
        if (!item) {
            return;
        }
        var productRoute = getProductRoute(item, getRoute);
        var productLink = "";
        if (item === null || item === void 0 ? void 0 : item.color) {
            var paramStr = "?color=".concat(item === null || item === void 0 ? void 0 : item.color);
            productLink = productRoute + paramStr;
        } else if ((0,canShowPDPSystem/* canShowPDPSystem */.R)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            productLink = productRoute;
        }
        return productLink || "";
    };
    return [
        onItemClick,
        getLink
    ];
}


/***/ }),

/***/ 106531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useSetWishlistState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269396);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(225617);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(667294);
/* harmony import */ var _components_Common_Toast__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40804);
/* harmony import */ var _redux_actions_wishlist__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(847228);
/* harmony import */ var src_constants_wishlist__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(298627);
/* harmony import */ var src_redux_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(731024);









function useSetWishlistState() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useDispatch */ .I0)();
    var ref = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        var ref, ref1, ref2;
        return {
            storeData: (ref = state.storeReducer) === null || ref === void 0 ? void 0 : ref.store,
            userData: (ref1 = state.userReducer) === null || ref1 === void 0 ? void 0 : ref1.data,
            isLogin: (ref2 = state.userReducer) === null || ref2 === void 0 ? void 0 : ref2.isLogin
        };
    }), storeData = ref.storeData, userData = ref.userData, isLogin = ref.isLogin;
    var setWishlistState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function(payload, callback) {
        var showCustomToast = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        if (!isLogin && (payload === null || payload === void 0 ? void 0 : payload.status) !== src_constants_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .ITEM_WISHLIST_STATE.ADD_TO_CART */ .U.ADD_TO_CART) {
            dispatch((0,src_redux_actions__WEBPACK_IMPORTED_MODULE_4__/* .toggleGlobalAuthModal */ .Qi)(true));
            callback(false);
            return;
        }
        payload = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, payload), {
            user_id: userData === null || userData === void 0 ? void 0 : userData.user_id,
            user_phone: userData === null || userData === void 0 ? void 0 : userData.phone,
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            user_email: userData === null || userData === void 0 ? void 0 : userData.email
        });
        dispatch((0,_redux_actions_wishlist__WEBPACK_IMPORTED_MODULE_7__/* .setItemWishlistState */ .qC)(payload, function(status) {
            if (status) {
                (payload === null || payload === void 0 ? void 0 : payload.status) !== src_constants_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .ITEM_WISHLIST_STATE.ADD_TO_CART */ .U.ADD_TO_CART ? (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_2__/* .toastNotifySuccess */ .jh)((payload === null || payload === void 0 ? void 0 : payload.status) === src_constants_wishlist__WEBPACK_IMPORTED_MODULE_3__/* .ITEM_WISHLIST_STATE.ITEM_WISHLISTED */ .U.ITEM_WISHLISTED ? "Item added to wishlist" : "Item removed from wishlist") : showCustomToast && (0,_components_Common_Toast__WEBPACK_IMPORTED_MODULE_2__/* .toastNotifySuccess */ .jh)("".concat((showCustomToast === null || showCustomToast === void 0 ? void 0 : showCustomToast.msg) || "Wishlist updated"));
                dispatch((0,_redux_actions_wishlist__WEBPACK_IMPORTED_MODULE_7__/* .getWishlistItemCountByUser */ .OG)({
                    store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id
                }));
                callback(true);
            }
        }));
    }, [
        isLogin,
        storeData
    ]);
    return {
        setWishlistState: setWishlistState
    };
}


/***/ }),

/***/ 813051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ canShowPDPSystem; }
/* harmony export */ });
var canShowPDPSystem = function(themeVar) {
    switch(themeVar){
        case 1:
            return true;
        case 2:
            return true;
        case 3:
            return false;
        case 4:
            return false;
        default:
            return true;
    }
};


/***/ }),

/***/ 755847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ getMetaDescription; }
/* harmony export */ });
/**
 * @param {object} storeInfo
 * @param {object} seoDetails
 * @return {string}
 */ var getMetaDescription = function(storeInfo) {
    var seoDetails = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    var ref;
    if (!storeInfo) return "";
    if (seoDetails) return seoDetails.description;
    var description = storeInfo === null || storeInfo === void 0 ? void 0 : (ref = storeInfo.default_seo) === null || ref === void 0 ? void 0 : ref.meta_description;
    return description || "";
// const businessTypes = storeInfo.store_businesses;
// const isAddresVisible = storeInfo?.address?.visibility === 1 ? true : false;
// let match = 13;
// let description = '';
// // default
// if (businessTypes && businessTypes.length > 1) {
//   match = 11;
// } else if (
//   businessTypes &&
//   businessTypes.length === 1 &&
//   businessTypes[0].business_id === 8
// ) {
//   match = 11;
// } else if (businessTypes && businessTypes.length === 0) {
//   match = 11;
// }
// // Genral store
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 1)
//   match = 1;
// // Pharmacy & Wellness
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 2)
//   match = 2;
// // Mobile & Electronics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 3)
//   match = 3;
// // Clothing & Fashion
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 4)
//   match = 4;
// // Resturants, Food Joints & Bakery
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 5)
//   match = 5;
// // Stationary & Office Supplies
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 6)
//   match = 6;
// // Arts, Jewellery & Collections
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 7)
//   match = 7;
// // Fruits & Vegetables
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 13)
//   match = 8;
// // Furniture & Home Decor
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 14)
//   match = 9;
// // Beauty & Cosmetics
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 15)
//   match = 10;
// // real estate
// if (businessTypes && businessTypes.length === 1 && businessTypes[0].business_id === 16)
//   match = 12;
// switch (match) {
//   case 1:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Grocery & Dairy Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 2:
//     description = `Buy and Order online from  ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Pharmacy & Wellness Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 3:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Mobile & Electronics Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 4:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fashion Store - ${`${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ''
//     }`}. Order Now!`;
//     break;
//   case 5:
//     description = `Order Food online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }|  Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     } . Order Now!`;
//     break;
//   case 6:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Stationary Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 7:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Arts, Jewellery & Collections Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 8:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Fruits & Vegetables Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 9:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Furniture & Home Decor Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 10:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Online Beauty & Cosmetics Store - ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 11:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
//   case 12:
//     description = `Buy / Sell / Rent your real estate dream property from ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     } | Real Estate Property ${storeInfo.store_info?.name}. Explore Now!`;
//     break;
//   default:
//     description = `Buy and Order online from ${storeInfo.store_info?.name}${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city} ` : ''
//     }| Now order online & pay using UPI, Paytm, GooglePay, PhonePe at ${
//       storeInfo.store_info?.name
//     }${
//       isAddresVisible && storeInfo.address?.city ? `,${storeInfo.address?.city}` : ``
//     }. Order Now!`;
//     break;
// }
// return description;
};


/***/ }),

/***/ 254051:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ redirectToHomePage; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(540190);


var redirectToHomePage = function(path, domain) {
    next_router__WEBPACK_IMPORTED_MODULE_0___default().push((0,_routes__WEBPACK_IMPORTED_MODULE_1__.getRoute)(path, domain));
};


/***/ }),

/***/ 982983:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ selectedVariantFromVariantList; }
/* harmony export */ });
/**
 * get variant from list if selected variants in cart data
 * @param {*} cartData
 * @param {*} itemIndexInCart
 * @param {*} selectedVariantId
 * @return {*} selectedVariant
 */ var selectedVariantFromVariantList = function(cartData, itemIndexInCart, selectedVariantId) {
    if (cartData && itemIndexInCart > -1) {
        var ref, ref1;
        return cartData === null || cartData === void 0 ? void 0 : (ref = cartData.items) === null || ref === void 0 ? void 0 : (ref1 = ref[itemIndexInCart]) === null || ref1 === void 0 ? void 0 : ref1.variants_selected.find(function(variant) {
            return variant.variant_id === selectedVariantId;
        });
    }
    return 0;
};


/***/ }),

/***/ 698616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ specificThemeRender; }
/* harmony export */ });
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17247);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(186812);
/* harmony import */ var src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(423653);



var specificThemeRender = function(storeData) {
    var isSubscriptionDemoPreview = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var mainTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.theme) || {};
    var alternateTheme = (storeData === null || storeData === void 0 ? void 0 : storeData.store_premium_theme) || {};
    var isPremium = storeData === null || storeData === void 0 ? void 0 : storeData.premium;
    if (isSubscriptionDemoPreview || storeData.internal_admin_access === 1 || (storeData === null || storeData === void 0 ? void 0 : storeData.new_subscription_status) !== src_constants_subscription__WEBPACK_IMPORTED_MODULE_2__/* .NEW_SUBSCRIPTIONS_STATUS.INACTIVE */ .W0.INACTIVE) return mainTheme;
    var toggleMobileView = _redux_store__WEBPACK_IMPORTED_MODULE_0__/* ["default"].getState */ .Z.getState().commonReducer.toggleMobileView;
    if (_utils_deviceWidth__WEBPACK_IMPORTED_MODULE_1__/* .deviceWidth */ .o > 998) {
        return isPremium || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.is_demo) === 1 || (mainTheme === null || mainTheme === void 0 ? void 0 : mainTheme.brand_website_flag) > 0 ? mainTheme : toggleMobileView ? mainTheme : alternateTheme;
    }
    return mainTheme;
};


/***/ })

}]);